const dict = {
    en: {
        language: "English",
        or: "or",
        status: "Status",
        fast: "Fast",
        l2: "Built on Layer 2",
        l2_sub: "SATS Routing utilizes Layer 2 scaling technologies like the Lightning Network",
        assets_sub: "Bitcoin Layers",
        safe: "Safe",
        non_custodial: "Non-Custodial",
        non_custodial_sub:
            "Swaps on SATS Routing are atomic, cryptography ensures that users are always in control of their money",
        node: "Lightning Nodes",
        error: "Error",
        error_subline: "Invalid response from the API, something is wrong.",
        error_wasm: "WebAssembly not supported",
        history: "History",
        swap: "Swap",
        refund: "Refund",
        partner: "Partner",
        support: "Support",
        docs: "Docs",
        onion: "Onion",
        terms: "Terms",
        privacy: "Privacy",
        blockexplorer: "Open {{ typeLabel }}",
        blockexplorer_lockup_address: "lockup address",
        blockexplorer_lockup_tx: "Lockup Transaction",
        blockexplorer_claim_tx: "claim transaction",
        blockexplorer_refund_tx: "refund transaction",
        check_bridge_status: "Check bridge status",
        help: "Help",
        network_fee: "Network Fee",
        swap_fees: "Swap Fees",
        fee: "SATS Routing Fee",
        denomination: "Denomination",
        send: "Send",
        checking_previous_transaction: "Checking previous transaction",
        checking_previous_transaction_line:
            "Please wait while we check whether your wallet submitted the bridge transaction.",
        could_not_confirm_previous_transaction:
            "Could not confirm previous transaction",
        could_not_confirm_previous_transaction_line:
            "We could not confirm whether your wallet submitted the bridge transaction.",
        checking_previous_transaction_countdown:
            "{{ seconds }} seconds remaining.",
        check_again: "Check again",
        did_not_send_transaction: "I didn't send a transaction",
        did_not_send_transaction_confirm:
            "Only continue if you are sure your wallet did not submit the transaction. Continuing can make you send funds twice.",
        continue: "Continue",
        receive: "Receive",
        max: "Max",
        minimum_amount: "Minimum amount is {{ amount }} {{ denomination }}",
        maximum_amount: "Maximum amount is {{ amount }} {{ denomination }}",
        assets: "Multi-Layer",
        footer: "Made with 🧡 by SATS Routing",
        create_swap: "Create Swap",
        get_gas_token_for_gas: "Get {{ gasToken }} for gas",
        new_swap: "New Swap",
        feecheck:
            "Network fee was updated based on network situation, please confirm new amounts and continue with swap.",
        amount_limits_changed:
            "Swap limits changed. Please confirm new amounts and continue with swap.",
        commitment_invoice_heading:
            "Enter a Lightning Invoice for {{ amount }} {{ denomination }}",
        commitment_invoice_deferred:
            "Enter Lightning destination after payment",
        clear_amount: "Clear",
        create_and_paste:
            "Paste a Lightning invoice, BOLT12 or LNURL to receive funds",
        invoice_cleared_amount_changed:
            "Invoice cleared because the amount changed.",
        congrats: "Congratulations!",
        successfully_swapped:
            "You successfully received {{ amount }} {{ denomination }}!",
        bridge_transfer_pending:
            "Swap complete! Your {{ amount }} {{ denomination }} was sent via the {{ network }} bridge. Bridge transfers may take a few minutes to finish.",
        timeout_eta: "Timeout ETA",
        pay_invoice: "Swap: {{ id }}",
        pay_swap_404: "Swap not found!",
        pay_timeout_blockheight: "Timeout Block Height ({{ network }})",
        send_to: "Send {{ amount }} {{ denomination }} to",
        send_between:
            "Send between {{ min }} and {{ max }} {{ denomination }} to",
        pay_invoice_to:
            "Pay this invoice about {{ amount }} {{ denomination }}",
        no_wallet: "No wallet installed",
        connect_wallet: "Connect wallet",
        please_connect_wallet: "Please connect wallet",
        connect_to_address: "Connect to swap address",
        disconnect_address: "Disconnect wallet",
        lockup_failed: "Lockup Failed!",
        failure_reason: "Failure reason",
        invoice_payment_failure: "Could not pay your lightning invoice",
        onchain_address: "Enter {{ asset }} address to receive funds",
        onchain_address_no_asset: "Enter address",
        invalid_refund_file: "Invalid rescue key",
        invalid_invoice:
            "Please provide a valid Lightning invoice, BOLT12 or LNURL",
        invalid_0_amount: "Invoices without amount are not supported",
        copy_invoice: "Lightning invoice",
        copy_address: "Address",
        copy_amount: "Amount",
        copy_bip21: "BIP21",
        rescue_a_swap_subline:
            "If you sent BTC or LBTC into a SATS Routing swap, upload or enter your rescue key to rescue a swap that is not available in this browser’s swap history.",
        rescue_a_swap_mnemonic:
            "Enter your rescue key to rescue a swap that is not available in this browser’s swap history.",
        refund_past_swaps: "Past swaps",
        refund_past_swaps_subline:
            "Swaps that got saved into your browsers storage",
        no_rescuable_swaps: "No rescuable swaps found in your browser history",
        refund_external_scanning_evm:
            "Scanning for rescuable swaps across EVM chains...",
        connected_wallet_no_swaps:
            "The connected wallet does not contain any rescuable swaps.",
        history_no_swaps: "Looks like you didn't do any swaps yet.",
        refund_address_header:
            "Enter a {{ asset }} address to receive your refund on:",
        refund_address_header_no_asset:
            "Enter an address to receive your refund on:",
        history_export: "Export",
        refund_clear: "Delete storage",
        delete_storage:
            "Are you sure you want to clear your storage?\nYour swap information and you refund / claim private keys will be lost.",
        delete_storage_single_swap:
            "Are you sure you want to clear Swap {{ id }} from your storage?\nYour swap information and you refund / claim private keys will be lost.",
        delete_logs: "Are you sure you want to clear your logs?",
        tx_in_mempool: "Transaction is in mempool",
        tx_in_mempool_subline: "Waiting for confirmation to complete the swap.",
        tx_in_mempool_warning:
            "Keep this page open, otherwise your swap can't complete!",
        invoice_pending: "Transaction received, paying invoice.",
        invoice_pending_pro:
            "Transaction received, invoice queued. In some occasions, swap might be cancelled.",
        invoice_expired: "Invoice expired, try again!",
        create_invoice_webln: "Create invoice via WebLN",
        pay_invoice_webln: "Pay invoice via WebLN",
        select_asset_send: "Select send asset",
        select_asset_receive: "Select receive asset",
        select_network: "Select network",
        search: "Search",
        tx_confirmed: "Transaction confirmed",
        tx_ready_to_claim: "Claiming transaction now...",
        refunded: "Swap has been refunded successfully!",
        refunded_bridge_pending:
            "Swap has been refunded. Your {{ denomination }} is being bridged back to {{ network }} and may take some time to arrive.",
        locktime_not_satisfied: "Locktime requirement not satisfied",
        already_refunded: "Swap already refunded",
        api_offline: "API is offline",
        api_offline_msg:
            "Could not connect to the SATS Routing API, please try again later",
        refund_explainer: "You will be able to refund after the swap timeout!",
        wasm_not_supported: "Please activate WebAssembly in your browser",
        created: "Created",
        view: "View",
        id: "ID",
        headline: "Non-Custodial Bitcoin Bridge",
        headline_pro: "Stack Sats Non-Custodially",
        subline:
            "Swap between different Bitcoin layers while staying in full control.",
        subline_pro:
            "Earn sats for swapping Bitcoin in directions that help balance our liquidity.",
        start_swapping: "Start Swapping",
        partners: "Partners",
        integrations: "Integrations",
        oldest_channel_years: "{{ years }} yrs",
        oldest_channel: "Oldest Channel",
        capacity: "Capacity ({{ denomination }})",
        peers: "Number of Peers",
        num_channels: "Number of Channels",
        beta_caution: "BETA - USE WITH CAUTION!",
        pro: "pro",
        pro_banner: "Looking to use SATS Routing Pro via API?",
        warning_return:
            "Return to this page after paying the invoice! The payment might show pending until you return to this page.",
        warning_expiry:
            "Make sure your transaction confirms within ~24 hours after creation of this swap!",
        not_found: "404 - Not Found",
        not_found_subline: "This page seems to have vanished.",
        back_to_home: "Back to Home",
        transaction_prompt:
            'Press "{{ button }}" in order to open your connected wallet and confirm the displayed transaction.',
        transaction_prompt_receive:
            'Press "{{ button }}" to start claiming {{ asset }}.',
        transaction_failed: "Transaction failed: {{ error }}",
        wallet_request_rejected: "Request was rejected in your wallet.",
        invalid_address: "Invalid {{ asset }} address",
        scan_qr_code: "Scan QR Code",
        version: "Version",
        commithash: "Commit Hash",
        open_in_wallet: "Open in Wallet",
        branding: "Branding",
        regtest: "Regtest",
        broadcasting_claim: "Broadcasting claim transaction...",
        paste_invalid:
            "Clipboard contains invalid characters or maximum amount is exceeded",
        email: "Email",
        switch_paste: "Switched swap direction/asset based on pasted content",
        settings: "Settings",
        decimal_separator: "Decimal Separator",
        denomination_tooltip: "Choose your preferred denomination: BTC or sats",
        decimal_tooltip:
            "Choose your preferred decimal separator: dot or comma",
        fiat_rate_not_available: "Fiat rate unavailable",
        fiat_currency: "Fiat currency",
        fiat_currency_tooltip: "Currency used for the fiat amount hint",
        swap_completed: "Swap {{ id }} completed successfully!",
        claim_fail: "Failed to claim swap: {{ id }}",
        logs: "Logs",
        logs_tooltip: "Logs of the web app, useful for debugging",
        share_with_support: "Share with support",
        chatwoot_not_ready:
            "Support chat is opening — please try sharing your logs again once it has loaded.",
        hide_wallet_address: "Privacy Mode",
        hide_wallet_address_tooltip:
            "Hides EVM wallet address and Swap ID for privacy in demos/recordings",
        bitcoin_only: "Bitcoin-Only Mode",
        bitcoin_only_tooltip:
            "Only show Bitcoin and Lightning, hide all other pairs",
        bitcoin_only_warning:
            "Bitcoin-Only Mode is enabled. Disable it in settings to swap other assets.",
        slippage: "Slippage",
        slippage_tooltip: "Maximum price slippage tolerance for DEX swaps",
        gas_topup: "Auto gas top-up",
        gas_topup_tooltip:
            "Automatically convert a small portion of your swap into native gas if your connected wallet has no gas.",
        gas_topup_label: "Destination gas ({{ gasToken }}) included",
        bridge_messaging_fee: "Bridge Messaging Fee",
        bridge_transfer_fee: "Bridge Transfer Fee",
        retry: "Retry",
        error_bridge_capacity: "Amount exceeds bridge capacity",
        error_no_quote:
            "A quote could not be obtained. Please check your connection and try again.",
        error_zero_quote: "Increase send amount",
        oft_eta: "Estimated arrival in about {{ time }}",
        oft_eta_day_unit: "{{ value }}d",
        oft_eta_hour_unit: "{{ value }}h",
        oft_eta_minute_unit: "{{ value }}m",
        oft_eta_second_unit: "{{ value }}s",
        oft_arriving_soon: "Arriving soon...",
        oft_transfer_in_progress: "Transfer in progress",
        waiting_for_bridge: "Waiting for {{ symbol }} bridge",
        dex_quote_changed: "DEX quote has changed",
        commitment_rejected_line:
            "The locked amount came up short, so this swap can't be completed. You can refund your funds back to your original address.",
        pre_bridge_dex_quote_blocked: "Quote has changed",
        pre_bridge_dex_quote_blocked_line:
            "Prices changed while your funds were bridging, so the quote is no longer enough to complete the swap. Please try again or refund your funds.",
        recovering_bridged_funds: "Refunding...",
        pre_bridge_refund_initiated:
            "Your funds are being bridged back to your original address and will arrive shortly.",
        retry_quote: "Retry",
        retrying_quote: "Checking quote...",
        zero_conf: "Zero-Conf",
        zero_conf_tooltip:
            "Accept transactions that are not yet confirmed in a block",
        on: "on",
        off: "off",
        invalid_pair: "Invalid pair",
        invalid_send_asset: "Invalid send asset",
        error_starting_qr_scanner:
            "Couldn't access camera, please check permissions!",
        insufficient_balance: "Insufficient balance",
        insufficient_balance_line:
            "You do not have enough balance in your wallet for this swap.",
        insufficient_gas_balance_line:
            "You do not have enough {{ gasToken }} to fund the swap.",
        select_wallet: "Select wallet",
        select_derivation_path: "Select derivation path",
        submit_derivation_path: "Submit",
        not_supported_in_browser: "Not supported in this browser",
        switch_network: "Switch network",
        block: "block",
        logs_scan_progress: "Scan progress {{ value }}%",
        logs_deriving_keys: "Deriving keys... ({{ count }} so far)",
        accept: "Accept",
        wallet_connect_failed: "Wallet connection failed: {{ error }}",
        ledger_open_app_prompt: "Open Ethereum or RSK app",
        validate_payment: "Show Proof of Payment",
        no_browser_wallet: "No browser wallet detected",
        sent: "Sent",
        will_receive: "Will receive",
        refund_available_in: "Refund will be available in {{ blocks }} blocks",
        no_wallet_connected: "No wallet connected",
        no_lockup_transaction: "No lockup transaction found",
        routing_fee_limit: "Routing Fee Limit",
        download_boltz_rescue_key: "SATS Routing Rescue Key",
        download_boltz_rescue_key_subline:
            "Back up all your swaps with a single Rescue Key 🙌",
        download_boltz_rescue_key_subline_second:
            "This key works on any device and for all swaps created with it.",
        download_boltz_rescue_key_subline_backup:
            "To continue, please back it up.",
        download_boltz_rescue_key_subline_privacy:
            "**Careful:** Privacy-focused browsers may delete downloaded files when closed.",
        download_boltz_rescue_key_subline_save:
            "Save the Rescue Key in a **SECURE** and **PERMANENT** location!",
        download_boltz_rescue_key_subline_warning:
            "Failing to do so may lead to **LOSS OF FUNDS**.",
        download_new_key: "Download rescue key",
        verify_boltz_rescue_key: "Verify SATS Routing Rescue Key",
        verify_boltz_rescue_key_subline:
            "Please select your previously saved SATS Routing Rescue Key to verify it.",
        verify_key: "Verify key",
        verify_key_failed:
            "Verification of the SATS Routing Rescue Key failed. We recommend downloading a new SATS Routing Rescue Key to continue.",
        rescue_key: "Rescue Key",
        reset_rescue_key_tooltip:
            "Generate a new Rescue Key and wipe all swap data",
        reset_rescue_key_prompt:
            "⚠️ WARNING: This will delete ALL your swap data and generate a new Rescue Key.\n\nDon't proceed unless you have a backup of your existing Rescue Key or you're absolutely sure you won't need it. \n\nType 'confirm' to proceed:",
        reset_rescue_key_invalid_confirmation:
            "Invalid confirmation. Please type 'confirm' to proceed.",
        reset_rescue_key_error:
            "An error occurred while resetting the Rescue Key. Please reload this page and try again.\n\nError: {{ error }}",
        reset_rescue_key_success: "New Rescue Key generated successfully!",
        encrypt_rescue_key: "Encrypt",
        decrypt_rescue_key: "Remove encryption",
        encrypt_rescue_key_tooltip:
            "Encrypt the Rescue Key at rest with a passphrase. You will need the passphrase to unlock it in this browser.",
        set_rescue_passphrase_prompt:
            "Enter a passphrase to encrypt your Rescue Key at rest.\n\nWARNING: if you forget this passphrase and have no Rescue Key backup, your funds are unrecoverable.",
        confirm_rescue_passphrase_prompt: "Re-enter the passphrase to confirm:",
        rescue_passphrase_empty: "The passphrase must not be empty.",
        rescue_passphrase_mismatch:
            "The passphrases do not match. Please try again.",
        encrypt_rescue_key_success: "Rescue Key encrypted successfully!",
        encrypt_rescue_key_error:
            "An error occurred while encrypting the Rescue Key.\n\nError: {{ error }}",
        disable_rescue_encryption_prompt:
            "Remove passphrase encryption and store the Rescue Key in the clear again?\n\nType 'confirm' to proceed:",
        disable_rescue_encryption_success: "Encryption removed.",
        unlock_rescue_key_title: "Unlock your Rescue Key",
        unlock_rescue_key_description:
            "Your Rescue Key is encrypted. Enter your passphrase to unlock it and continue.",
        unlock_rescue_key_placeholder: "Passphrase",
        unlock_rescue_key_button: "Unlock",
        unlock_rescue_key_invalid: "Invalid passphrase. Please try again.",
        no_swaps_found: "No swaps found",
        rif_extra_fee:
            "Wallet doesn't contain enough RBTC, fee adjusted to include RIF Relay fee!",
        back: "Back",
        next: "Next",
        pagination_info: "Page {{ start }} of {{ end }}",
        generate_key: "Generate new key",
        show_rescue_key_instead: "Show the 12-word rescue key instead",
        backup_boltz_rescue_key: "Backup SATS Routing Rescue Key",
        backup_boltz_rescue_key_subline_second:
            "This new key works on any device and works for all swaps created with it.",
        backup_boltz_rescue_key_subline_third:
            "Please write down or copy this key and store it in a secure and permanent location.",
        backup_boltz_rescue_key_reminder: "Keep this safe. Do not share.",
        copy_rescue_key: "Copy rescue key",
        user_saved_key: "I have saved the rescue key",
        verify_mnemonic_word: {
            start: "What is the word at ",
            strong: "position {{ number }}",
            end: " of your rescue key?",
        },
        incorrect_word: "Incorrect word. Please double-check your rescue key.",
        enter_mnemonic: "Enter rescue key",
        verify_boltz_rescue_key_mnemonic:
            "Please enter your rescue key below to import it.",
        hint_paste_mnemonic: "Hint: you can paste all 12 words at once.",
        swap_opportunities: "Available Pro Opportunities",
        swap_opportunities_subline:
            "Earn sats or get a discount by swapping these pairs",
        pro_fee: "Pro Rate",
        regular_fee: "Regular Rate",
        swap_opportunities_accordion: "Pro Opportunities",
        no_opportunities_found: {
            text: "No Pro opportunities found at the moment. Please check again later.",
            telegram_bot_text_prefix: "For fee alerts, check out our ",
            telegram_bot_text_middle: " or ",
            telegram_bot_text_suffix: " bot.",
            telegram_bot: "Telegram",
            simplex: "SimpleX",
        },
        refresh_for_refund:
            "If you sent Bitcoin into this swap, refresh the page to check for a refund.",
        applied_routing_hint:
            "Your recipient supports receiving {{ asset }} directly. This saves you fees and they still get the full amount.",
        optimized_route_amount:
            "Swap route optimized, saving you ~{{ amount }} {{ denomination }}",
        claim: "Claim",
        claimed: "Swap has been claimed successfully!",
        rescue: "Rescue",
        rescue_swaps: "Rescue swaps",
        rescue_swap: "Rescue Swap",
        failed_get_swap: "Could not get swap {{ id }}",
        failed_get_swap_subline:
            "Please re-insert the rescue key and try again.",
        in_progress: "In progress",
        completed: "Completed",
        get_refundable_error:
            "Failed to load UTXO data. Refresh to try again or check your internet connection if the problem persists.",
        min_amount_destination:
            "Minimum amount for the destination address is {{ amount }} {{ denomination }}",
        max_amount_destination:
            "Maximum amount for the destination address is {{ amount }} {{ denomination }}",
        exact_amount_destination:
            "Invoice amount must be exactly {{ amount }} {{ denomination }}",
        destination: "Destination",
        destination_address: "{{ address }}",

        // Products page
        products: "Products",
        products_description:
            "A suite of products for seamless interoperability between Bitcoin layers",
        products_plugin_title: "SATS Routing BTCPay Plugin",
        products_plugin_description:
            "A non-custodial solution to easily accept Lightning payments without running a Lightning node",
        products_client_title: "SATS Routing Client",
        products_client_description:
            "Our enterprise-grade swap daemon for server integrations and liquidity management",
        products_pro_title: "SATS Routing Pro",
        products_pro_description:
            "A platform for earning sats non-custodially by providing just-in-time liquidity",
        learn_more: "Learn more",
        get_started: "Open SATS Routing Pro",
        documentation: "Documentation",
        view_on_github: "View on Github",
        chat_with_us: "Chat with us",

        // Plugin
        boltz_plugin_name: "SATS Routing BTCPay Plugin",
        boltz_plugin_description:
            "Non-custodial solution to easily accept Lightning payments",
        boltz_plugin_step_install_title: "Add the plugin",
        boltz_plugin_step_install_description:
            "Install the SATS Routing plugin on your BTCPay Server",
        boltz_plugin_step_setup_title: "Set up your wallet",
        boltz_plugin_step_setup_description:
            "Connect your external wallet or create a new one",
        boltz_plugin_step_paid_title: "Accept Lightning",
        boltz_plugin_step_paid_description:
            "Receive Lightning payments that auto-settle to mainchain Bitcoin",
        boltz_plugin_features_title: "Why use it?",
        boltz_plugin_features_description:
            "Built for merchants who want full control without complexity",
        boltz_plugin_feature_flexible_title: "Flexible",
        boltz_plugin_feature_flexible_description:
            "Accept Lightning payments without running a node or fully manage liquidity of an existing Lightning node",
        boltz_plugin_feature_liquid_title: "Powered by Liquid",
        boltz_plugin_feature_liquid_description:
            "Fully leverage the power of Liquid Taproot Swaps for low fees and increased privacy",
        boltz_plugin_feature_autoswap_title: "Settle on Bitcoin",
        boltz_plugin_feature_autoswap_description:
            "Autoswap to mainchain Bitcoin based on your preferences",
        boltz_plugin_feature_self_custodial_title: "Non-custodial",
        boltz_plugin_feature_self_custodial_description:
            "Stay in full control of your Bitcoin, powered by SATS Routing Atomic Swaps",

        boltz_plugin_questions_title: "Questions?",
        boltz_plugin_questions_subtitle: "We'd love to hear from you!",
        // Client
        boltz_client_name: "SATS Routing Client",
        boltz_client_description:
            "Enterprise-grade swap daemon for server integrations and liquidity management",
        boltz_client_features_title: "Built for Professionals",
        boltz_client_features_description:
            "Powerful features designed for professional Lightning node operators",
        boltz_client_feature_taproot_title: "Taproot-First",
        boltz_client_feature_taproot_description:
            "Leveraging Taproot Swaps for enhanced efficiency and privacy",
        boltz_client_node_agnostic_title: "Node Agnostic",
        boltz_client_node_agnostic_description:
            "First-class citizen support for CLN in addition to LND, giving you flexibility in your node infrastructure setup",
        boltz_client_autoswap_title: "Intelligent Autoswap",
        boltz_client_autoswap_description:
            "Fine-grained control for automated channel rebalancing with customizable thresholds, preferences, and smart settlement on Bitcoin",
        boltz_client_liquid_title: "Liquid-First",
        boltz_client_liquid_description:
            "Optimized for channel rebalancing using Liquid swaps for low fees and fast execution",
        boltz_client_cli_title: "Powerful API & CLI",
        boltz_client_cli_first_paragraph:
            "Built-in wallet system and comprehensive API for seamless integration into your infrastructure.",
        boltz_client_cli_second_paragraph:
            "Monitor, control, and automate everything from the command line or your own applications.",
        boltz_client_cta_title: "Ready to add SATS Routing to your infrastructure?",
        boltz_client_cta_subtitle:
            "Join enterprises and node runners trusting SATS Routing Client",

        // Pro
        boltz_pro_name: "SATS Routing Pro",
        boltz_pro_description: "A platform for earning sats non-custodially",
        boltz_pro_how_it_works_title: "How it works",
        boltz_pro_how_it_works_description:
            "You get paid for swapping in directions that help us rebalance our liquidity",
        boltz_pro_chart_title: "SATS Routing Pro Fee History Sample",
        boltz_pro_chart_y_axis: "SATS Routing Pro Fee",
        boltz_pro_chart_x_axis: "Date",
        boltz_pro_negative_fee: "You earn sats",
        boltz_pro_lower_fee: "You save sats",
        boltz_pro_regular_fee: "Regular SATS Routing Fee",
        boltz_pro_target_audience_title: "Who is SATS Routing Pro For?",
        boltz_pro_target_audience_subtitle:
            "Built for professionals seeking earn opportunities, not for everyday payments",
        boltz_pro_perfect_for_title: "Built For",
        boltz_pro_perfect_for_1:
            "Lightning node operators looking to decrease excess inbound liquidity to earn sats",
        boltz_pro_perfect_for_2:
            "Professionals collaborating with external node operators to manage liquidity",
        boltz_pro_perfect_for_3:
            "Users topping up Lightning wallets within routing limits",
        boltz_pro_not_designed_for_title: "Not Designed For",
        boltz_pro_not_designed_for_1:
            "Everyday Lightning payments, like buying a coffee",
        boltz_pro_not_designed_for_2:
            "Payment reliability to destinations with high routing fees",
        boltz_pro_not_designed_for_3:
            "Scenarios requiring guaranteed instant settlement",
        boltz_pro_cta_title: "Start earning sats now!",
        boltz_pro_cta_subtitle:
            "Head over to SATS Routing Pro and check out the latest earn opportunities",
        boltz_pro_options_title: "3 ways to use it",
        boltz_pro_options_subtitle: "Choose what fits you best",
        boltz_pro_option_client_title: "SATS Routing Client",
        boltz_pro_option_client_description:
            "Fully automate SATS Routing Pro via API & CLI",
        boltz_pro_option_web_title: "Web App",
        boltz_pro_option_web_description:
            "Monitor and execute swap opportunities via web",
        boltz_pro_option_chat_title: "Chat Bots",
        boltz_pro_option_chat_description_prefix: "Get instant alerts in",
        boltz_pro_option_chat_description_middle: "or",
        boltz_pro_option_chat_description_suffix: ".",

        balance: "Balance",
        display: "Display",
        security: "Security",
        failed: "Failed",
        swaps_found: "Scanning swaps ({{ count }} found)",
        claim_scan_required:
            "To claim this swap, go back and scan with your rescue file uploaded.",
        refund_scan_required:
            "To refund this balance, go back and scan with your rescue file uploaded.",
        refund_destination_hint:
            "Funds will be refunded as {{ symbol }} on {{ network }} to your connected EVM wallet.",
        invalid_rescue_key_evm:
            "This rescue key is not associated with this swap. Please try again using a different rescue key.",
        error_occurred: "An error occurred: {{ error }}",
        rescue_external_select_method: "Select at least one rescue method",
        rescue_external_subtitle:
            "Use this page to rescue swaps that are not available in the history tab.",
        rescue_external_report_issue_start:
            "If you think your swap failed due to an issue on our side, please ",
        rescue_external_report_issue_link: "click here",
        rescue_external_report_issue_end:
            " to share logs and give us some details about your swap.",
        rescue_external_coverage: "Rescuable with the provided rescue methods",
        rescue_external_requires_rescue_key: "Requires rescue key",
        rescue_external_requires_wallet: "Requires wallet",
        rescue_external_requires_rescue_key_wallet:
            "Requires rescue key and wallet",
        rescue_external_resume: "Resume",

        evm_rescue_prompt:
            'If you sent funds into a SATS Routing swap on an EVM chain, use "Refund Swap"; if you were receiving funds from an EVM chain, use "Resume Swap" to rescue a swap that is not available in this browser’s swap history.',
        evm_rescue_refund_title: "Refund Swap",
        start_scanning: "Start scanning",
        stop_scanning: "Stop scanning",
        evm_rescue_resume_title: "Resume Swap",
        evm_rescue_resume_explainer:
            "Use your rescue key to find pending swaps that can be resumed.",
        unmatched_swaps:
            "This wallet has {{ count }} additional rescuable swaps. To access them, please switch to the Rescue Key used to initiate those swaps.",
        approve: "Approve",
        approve_allowance_line:
            "Set {{ tokenStandard }} allowance for the swap contract",
        approve_allowance_reset_line:
            "Some {{ tokenStandard }} tokens require resetting the allowance to 0 before setting a new amount. You may need to approve twice.",
        upload_rescue_key: "Select Rescue Key",

        suspension_status: "Swap Services Disabled",
        suspension_p1: "Update: SATS Routing will stay disabled until further notice.",
        suspension_p2:
            "Our API remains available to process refunds cooperatively. In any case, unilateral refunds will work, as they do not depend on our infrastructure.",
        suspension_p3: "Our support team stays reachable.",
        suspension_p4:
            "To be clear: this is not a response to a single incident. Over the past months we have seen a steady rise in automated, AI-assisted probing of our infrastructure, and we have dealt with several exploits. Each was contained, but the pattern is clear: attackers now iterate faster than a team our size can find and patch. In the past few days alone we saw a drastic acceleration, and we do not believe this asymmetry will reverse. After reviewing the results of our own recent security scans, we cannot responsibly re-enable SATS Routing swaps, especially as we are being actively targeted by what appear to be multiple resourceful groups while we race to deploy fixes.",
        suspension_p5:
            "What we are seeing is a major paradigm shift for Bitcoin services operating on an open source stack, and it needs careful analysis. Do not expect swap services to resume shortly.",
        suspension_p6:
            "To be explicit: no user funds were ever at risk. SATS Routing is non-custodial by design. And as a fully bootstrapped company, the losses were ours alone.",
        suspension_p7:
            "We don't know yet how things will continue from here, but we'll keep you posted as soon as we have had the time to catch our breath and make a decision 🙏",
        suspension_date: "3 August 2026 · View on X",
    },
    de: {
        language: "Deutsch",
        or: "oder",
        status: "Status",
        fast: "Schnell",
        l2: "Auf Layer-2 gebaut",
        l2_sub: "SATS Routing nutzt Layer-2 Skalierungstechnologien wie das Lightning-Netzwerk",
        assets_sub: "Bitcoin-Layer",
        safe: "Sicher",
        non_custodial: "Non-Custodial",
        non_custodial_sub:
            "Swaps auf SATS Routing sind atomar, Kryptografie stellt sicher, dass Nutzer stets die Kontrolle über ihre Bitcoin behalten",
        node: "Lightning-Knoten",
        error: "Fehler",
        error_subline:
            "Ungültige Antwort von der API, irgendwas ist hier falsch gelaufen.",
        error_wasm: "WebAssembly nicht unterstützt",
        history: "Historie",
        swap: "Swap",
        refund: "Rückerstattung",
        partner: "Partner",
        support: "Hilfe",
        docs: "Docs",
        onion: "Onion",
        terms: "Nutzungsbedingungen",
        privacy: "Datenschutz",
        blockexplorer: "{{ typeLabel }} anzeigen",
        blockexplorer_lockup_address: "Lockupadresse",
        blockexplorer_lockup_tx: "Lockuptransaktion",
        blockexplorer_claim_tx: "Claimtransaktion",
        blockexplorer_refund_tx: "Rückerstattungstransaktion",
        check_bridge_status: "Bridge-Status prüfen",
        help: "Hilfe",
        network_fee: "Netzwerkgebühr",
        swap_fees: "Swap-Gebühren",
        fee: "SATS Routing Gebühr",
        denomination: "Denominierung",
        send: "Sende",
        checking_previous_transaction: "Vorherige Transaktion wird geprüft",
        checking_previous_transaction_line:
            "Bitte warte, während wir prüfen, ob dein Wallet die Bridge-Transaktion übermittelt hat.",
        could_not_confirm_previous_transaction:
            "Vorherige Transaktion konnte nicht bestätigt werden",
        could_not_confirm_previous_transaction_line:
            "Wir konnten nicht bestätigen, ob dein Wallet die Bridge-Transaktion übermittelt hat.",
        checking_previous_transaction_countdown: "Noch {{ seconds }} Sekunden.",
        check_again: "Erneut prüfen",
        did_not_send_transaction: "Ich habe keine Transaktion gesendet",
        did_not_send_transaction_confirm:
            "Fahre nur fort, wenn du sicher bist, dass dein Wallet die Transaktion nicht übermittelt hat. Wenn du fortfährst, könntest du Geld zweimal senden.",
        continue: "Weiter",
        receive: "Empfange",
        max: "Max",
        minimum_amount: "Mindestbetrag ist {{ amount }} {{ denomination }}",
        maximum_amount: "Höchstbetrag ist {{ amount }} {{ denomination }}",
        assets: "Multi-layer",
        footer: "Mit 🧡 gemacht von SATS Routing",
        create_swap: "Erstelle Swap",
        get_gas_token_for_gas: "Erhalte {{ gasToken }} für Gas",
        new_swap: "Neuer Swap",
        feecheck:
            "Die Netzwerkgebühr wurde aufgrund der Netzwerksituation aktualisiert. Bitte bestätige die neuen Beträge und fahren mit dem Swap fort.",
        amount_limits_changed:
            "Swap-Limits haben sich geändert. Bitte bestätige die neuen Beträge und fahre mit dem Swap fort.",
        commitment_invoice_heading:
            "Lightning-Rechnung über {{ amount }} {{ denomination }} eingeben",
        commitment_invoice_deferred: "Lightning-Ziel nach Zahlung eingeben",
        clear_amount: "Löschen",
        create_and_paste:
            "Füge eine Lightning-Rechnung, BOLT12 oder LNURL des Empfängers ein",
        invoice_cleared_amount_changed:
            "Rechnung gelöscht, weil sich der Betrag geändert hat.",
        congrats: "Herzlichen Glückwunsch!",
        successfully_swapped:
            "Du hast erfolgreich {{ amount }} {{ denomination }} empfangen!",
        bridge_transfer_pending:
            "Swap abgeschlossen! Deine {{ amount }} {{ denomination }} wurden über die {{ network }}-Bridge gesendet. Bridge-Transfers können einige Minuten dauern.",
        timeout_eta: "Timeout-ETA",
        pay_invoice: "Swap: {{ id }}",
        pay_swap_404: "Swap nicht gefunden!",
        pay_timeout_blockheight: "Timeout Blockhöhe ({{ network }})",
        send_to: "Sende {{ amount }} {{ denomination }} an",
        send_between:
            "Sende zwischen {{ min }} und {{ max }} {{ denomination }} an",
        pay_invoice_to:
            "Zahle diese Rechnung über {{ amount }} {{ denomination }}",
        no_wallet: "Wallet ist nicht installiert",
        connect_wallet: "Wallet verbinden",
        please_connect_wallet: "Bitte Wallet verbinden",
        connect_to_address: "Mit Swap-Adresse verbinden",
        disconnect_address: "Wallet trennen",
        lockup_failed: "Lockup fehlgeschlagen!",
        failure_reason: "Grund für den Fehler",
        invoice_payment_failure:
            "Deine Lightning-Rechung konnte nicht bezahlt werden",
        onchain_address: "Gib eine {{ asset }} Empfangsadresse ein",
        onchain_address_no_asset: "Adresse",
        invalid_refund_file: "Ungültiger Rettungsschlüssel",
        invalid_invoice:
            "Bitte eine gültige Lightning-Rechnung, BOLT12 oder LNURL eingeben",
        invalid_0_amount: "Lightning-Rechnungen ohne Betrag nicht unterstützt",
        copy_invoice: "Lightning-Rechnung",
        copy_address: "Adresse",
        copy_amount: "Betrag",
        copy_bip21: "BIP21",
        rescue_a_swap_subline:
            "Lade deinen Rettungsschlüssel hoch oder gib ihn ein, um einen Swap zu retten, der nicht im Swap-Verlauf dieses Browsers verfügbar ist.",
        rescue_a_swap_mnemonic:
            "Gib deinen Rettungsschlüssel ein, um einen Swap zu retten, der nicht im Swap-Verlauf dieses Browsers verfügbar ist.",
        refund_past_swaps: "Historische Swaps",
        refund_past_swaps_subline:
            "Swaps, die in deinem Browser gespeichert wurden",
        no_rescuable_swaps:
            "Keine wiederherstellbaren Swaps im Browserverlauf gefunden",
        refund_external_scanning_evm:
            "Scanne nach wiederherstellbaren Swaps auf EVM-Chains...",
        connected_wallet_no_swaps:
            "Das verbundene Rootstock Wallet enthält keine wiederherstellbaren Swaps.",
        history_no_swaps:
            "Es sieht so aus, als hättest du noch nicht geswappt.",
        refund_address_header: "Adresse deines {{ asset }} Wallets eingeben",
        refund_address_header_no_asset: "Adresse deines Wallets eingeben",
        history_export: "Exportieren",
        refund_clear: "Speicher löschen",
        delete_storage:
            "Bist du sicher, dass du deinen Speicher löschen möchtest?\nDeine Swap-Informationen und Rückerstattungsschlüssel gehen dabei verloren.",
        delete_storage_single_swap:
            "Bist du sicher, dass du den Swap {{ id }} aus deinem Speicher löschen möchtest?\nDeine Swap-Informationen und Rückerstattungsschlüssel gehen dabei verloren.",
        delete_logs: "Bist du sicher, dass du deine Logs löschen möchtest?",
        tx_in_mempool: "Transaktion befindet sich im Mempool.",
        tx_in_mempool_subline:
            "Warte auf Bestätigung, um den Swap abzuschließen.",
        tx_in_mempool_warning:
            "Seite nicht schließen, sonst kann Swap nicht abgeschlossen werden!",
        invoice_pending: "Transaktion erhalten, Rechnung wird bezahlt.",
        invoice_pending_pro:
            "Transaktion erhalten, Rechnung in Warteschlange. In manchen Fällen kann der Swap abgebrochen werden.",
        invoice_expired: "Rechnung ist abgelaufen, bitte erneut versuchen!",
        create_invoice_webln: "Rechnung über WebLN erstellen",
        pay_invoice_webln: "Rechnung über WebLN bezahlen",
        select_asset_send: "Sende-Asset auswählen",
        select_asset_receive: "Empfangs-Asset auswählen",
        select_network: "Netzwerk auswählen",
        search: "Suchen",
        tx_confirmed: "Transaktion bestätigt!",
        tx_ready_to_claim: "Claime die Transaktion jetzt...",
        refunded: "Swap wurde erfolgreich erstattet!",
        refunded_bridge_pending:
            "Swap wurde erstattet. Dein {{ denomination }} wird zurück nach {{ network }} gebridged und kann einige Zeit dauern.",
        locktime_not_satisfied: "Locktime-Anforderung nicht erfüllt.",
        already_refunded: "Swap wurde bereits erstattet!",
        api_offline: "API ist offline",
        api_offline_msg:
            "Konnte keine Verbindung zur SATS Routing API herstellen. Bitte versuche es später noch einmal.",
        refund_explainer:
            "Du kannst nach dem Timeout eine Rückerstattung beantragen!",
        wasm_not_supported: "Bitte aktiviere WebAssembly in deinem Browser!",
        created: "Erstellt",
        view: "Anzeigen",
        id: "ID",
        headline: "Non-Custodial Bitcoin Bridge",
        headline_pro: "Stacke Sats mit voller Kontrolle",
        subline:
            "Tausche zwischen verschiedenen Bitcoin-Layern, während du immer die volle Kontrolle behältst.",
        subline_pro:
            "Verdiene Sats für Swaps, die uns helfen unsere Liquidität zu managen.",
        start_swapping: "Starte Swap",
        partners: "Partner",
        integrations: "Integrationen",
        oldest_channel_years: "{{ years }} Jahre",
        oldest_channel: "Ältester Kanal",
        capacity: "Kapazität ({{ denomination }})",
        peers: "Anzahl der Peers",
        num_channels: "Anzahl der Kanäle",
        beta_caution: "BETA - OBACHT!",
        pro: "pro",
        pro_banner: "Möchten Sie SATS Routing Pro über die API nutzen?",
        warning_return:
            "Kehre nach dem Bezahlen der Rechnung zu dieser Seite zurück! Die Zahlung wird möglicherweise als ausstehend angezeigt, bis du zu dieser Seite zurückkehrst.",
        warning_expiry:
            "Wichtig: Die Transaktion muss innerhalb ~24 Stunden nach Erstellung dieses Swaps bestätigt sein!",
        not_found: "404 - Not Found",
        not_found_subline: "Diese Seite scheint verschwunden zu sein.",
        back_to_home: "Zurück zur Startseite",
        transaction_prompt:
            '"{{ button }}" klicken um das verbundene Wallet zu öffnen und bestätige die angezeigte Transaktion.',
        transaction_prompt_receive:
            '"{{ button }}" klicken, um {{ asset }} zu claimen.',
        transaction_failed: "Transaktion fehlgeschlagen: {{ error }}",
        wallet_request_rejected:
            "Die Anfrage wurde in deinem Wallet abgelehnt.",
        invalid_address: "Ungültige {{ asset }} Adresse",
        scan_qr_code: "QR Code scannen",
        version: "Version",
        commithash: "Commit Hash",
        open_in_wallet: "Im Wallet öffnen",
        branding: "Branding",
        regtest: "Regtest",
        broadcasting_claim: "Sende claim transaction...",
        paste_invalid:
            "Zwischenablage enthält ungültige Zeichen oder der maximale Betrag wurde überschritten",
        email: "Email",
        switch_paste:
            "Swap-Richtung/Asset basierend auf eingefügtem Inhalt gewechselt",
        settings: "Einstellungen",
        decimal_separator: "Dezimaltrennzeichen",
        denomination_tooltip:
            "Wähle deine bevorzugte Denomination: BTC oder sats",
        decimal_tooltip:
            "Wähle dein bevorzugtes Dezimaltrennzeichen: Punkt oder Komma",
        fiat_rate_not_available: "Fiat-Kurs nicht verfügbar",
        fiat_currency: "Fiat-Währung",
        fiat_currency_tooltip: "Für den Fiat-Hinweis verwendete Währung",
        swap_completed: "Swap {{ id }} erfolgreich abgeschlossen!",
        claim_fail: "Swap {{ id }} konnte nicht geclaimed werden!",
        logs: "Logs",
        logs_tooltip: "Logs der Web App, nützlich für Debugging",
        share_with_support: "Mit Support teilen",
        chatwoot_not_ready:
            "Der Support-Chat wird geöffnet — bitte versuche erneut, deine Logs zu teilen, sobald er geladen ist.",
        hide_wallet_address: "Privatsphäre-Modus",
        hide_wallet_address_tooltip:
            "Blendet EVM Wallet-Adresse und Swap ID aus für besser Privatsphäre in Demos und Bildschirmaufnahmen",
        bitcoin_only: "Bitcoin-Only Modus",
        bitcoin_only_tooltip:
            "Nur Bitcoin und Lightning anzeigen, alle anderen Paare ausblenden",
        bitcoin_only_warning:
            "Bitcoin-Only Modus ist aktiviert. Deaktiviere ihn in den Einstellungen, um andere Assets zu tauschen.",
        slippage: "Slippage",
        slippage_tooltip: "Maximale Slippage-Toleranz bei DEX-Swaps",
        gas_topup: "Auto Gas-Aufladung",
        gas_topup_tooltip:
            "Wandelt automatisch einen kleinen Teil deines Swaps in natives Gas um, wenn dein verbundenes Wallet kein Gas hat.",
        gas_topup_label: "Ziel-Gas ({{ gasToken }}) enthalten",
        bridge_messaging_fee: "Bridge-Messaging-Gebühr",
        bridge_transfer_fee: "Bridge-Transfer-Gebühr",
        retry: "Erneut versuchen",
        error_bridge_capacity: "Betrag übersteigt die Bridge-Kapazität",
        error_no_quote:
            "Ein Angebot konnte nicht abgerufen werden. Bitte prüfe deine Verbindung und versuche es erneut.",
        error_zero_quote: "Sendebetrag erhöhen",
        oft_eta: "Voraussichtliche Ankunft in etwa {{ time }}",
        oft_eta_day_unit: "{{ value }}T",
        oft_eta_hour_unit: "{{ value }}Std",
        oft_eta_minute_unit: "{{ value }}Min",
        oft_eta_second_unit: "{{ value }}s",
        oft_arriving_soon: "Gleich da...",
        oft_transfer_in_progress: "Übertragung läuft",
        waiting_for_bridge: "Warte auf {{ symbol }}-Bridge",
        dex_quote_changed: "DEX-Kurs hat sich geändert",
        commitment_rejected_line:
            "Der Betrag war zu gering, daher kann dieser Swap nicht abgeschlossen werden. Du kannst deine Gelder an deine ursprüngliche Adresse zurückerstatten.",
        pre_bridge_dex_quote_blocked: "Der Kurs hat sich geändert",
        pre_bridge_dex_quote_blocked_line:
            "Die Preise haben sich während der Bridge-Übertragung geändert, daher reicht der Kurs nicht mehr aus, um den Swap abzuschließen. Bitte versuche es erneut oder lass dir dein Guthaben erstatten.",
        recovering_bridged_funds: "Rückerstattung läuft...",
        pre_bridge_refund_initiated:
            "Deine Gelder werden über die Bridge an deine ursprüngliche Adresse zurückgesendet und treffen in Kürze ein.",
        retry_quote: "Erneut versuchen",
        retrying_quote: "Angebot wird geprüft...",
        zero_conf: "Zero-Conf",
        zero_conf_tooltip:
            "Akzeptiere Transaktionen, die noch nicht in einem Block bestätigt sind",
        on: "an",
        off: "aus",
        invalid_pair: "Ungültiges Paar",
        invalid_send_asset: "Ungültiges Sende-Asset",
        error_starting_qr_scanner:
            "Konnte nicht auf Kamera zugreifen, bitte Berechtigungen überprüfen!",
        insufficient_balance: "Unzureichendes Guthaben",
        insufficient_balance_line:
            "Du hast nicht genügend Guthaben für diesen Swap.",
        insufficient_gas_balance_line:
            "Du hast nicht genug {{ gasToken }}, um den Swap zu finanzieren.",
        select_wallet: "Wallet auswählen",
        select_derivation_path: "Ableitungspfad auswählen",
        submit_derivation_path: "Senden",
        not_supported_in_browser: "In diesem Browser nicht unterstützt",
        switch_network: "Netzwerk wechseln",
        block: "Block",
        logs_scan_progress: "Scan-Fortschritt {{ value }}%",
        logs_deriving_keys:
            "Schlüssel werden abgeleitet... (bisher {{ count }})",
        accept: "Akzeptieren",
        wallet_connect_failed:
            "Verbindung zu Wallet fehlgeschlagen: {{ error }}",
        ledger_open_app_prompt: "Ethereum oder RSK app öffnen",
        validate_payment: "Proof of Payment anzeigen",
        no_browser_wallet: "Kein Browser Wallet gefunden",
        sent: "Gesendet",
        will_receive: "Du erhältst",
        refund_available_in: "Rückerstattung möglich in {{ blocks }} Blöcken",
        no_wallet_connected: "Kein Wallet verbunden",
        no_lockup_transaction: "Keine Lockup-Transaktion gefunden",
        routing_fee_limit: "Routing Gebühr Limit",
        download_boltz_rescue_key: "SATS Routing Rettungsschlüssel",
        download_boltz_rescue_key_subline:
            "Sichere alle deine Swaps mit einem einzigen Rettungsschlüssel 🙌",
        download_boltz_rescue_key_subline_second:
            "Dieser Schlüssel funktioniert auf jedem Gerät und für alle Swaps, die mit ihm erstellt wurden.",
        download_boltz_rescue_key_subline_backup:
            "Um fortzufahren, sichere ihn bitte.",
        download_boltz_rescue_key_subline_privacy:
            "**Vorsicht:** Privacy-orientierte Browser können heruntergeladene Dateien beim Schließen löschen.",
        download_boltz_rescue_key_subline_save:
            "Bewahre den Rettungsschlüssel an einem **SICHEREN** und **DAUERHAFTEN** Ort auf!",
        download_boltz_rescue_key_subline_warning:
            "Andernfalls kann es zum **VERLUST VON GELDMITTELN** kommen.",
        download_new_key: "Rettungsschlüssel herunterladen",
        verify_boltz_rescue_key:
            "Existierenden SATS Routing Rettungsschlüssel verifizieren",
        verify_boltz_rescue_key_subline:
            "Bitte wähle den zuvor heruntergeladenen SATS Routing Rettungsschlüssel aus, um ihn zu verifizieren.",
        verify_key: "Schlüssel verifizieren",
        verify_key_failed:
            "Die Verifizierung des SATS Routing Rettungsschlüssels ist fehlgeschlagen. Wir empfehlen, einen neuen Rettungsschlüssel herunterzuladen.",
        rescue_key: "Rettungsschlüssel",
        reset_rescue_key_tooltip:
            "Generiere einen neuen Rettungsschlüssel und lösche alle Swap-Daten",
        reset_rescue_key_prompt:
            "⚠️ WARNUNG: Dies löscht ALLE deine Swap-Daten und generiert einen neuen Rettungsschlüssel.\n\nFahre nur fort, wenn du ein Backup deines aktuellen Rettungsschlüssels hast oder absolut sicher bist, dass du ihn nicht mehr benötigst.\n\nGib 'confirm' ein, um fortzufahren:",
        reset_rescue_key_invalid_confirmation:
            "Ungültige Bestätigung. Bitte gib 'confirm' ein, um fortzufahren.",
        reset_rescue_key_error:
            "Es ist ein Fehler beim Zurücksetzen des Rettungsschlüssels aufgetreten. Bitte versuche es erneut.\n\nFehler: {{ error }}",
        reset_rescue_key_success:
            "Neuer Rettungsschlüssel erfolgreich generiert!",
        encrypt_rescue_key: "Verschlüsseln",
        decrypt_rescue_key: "Verschlüsselung entfernen",
        encrypt_rescue_key_tooltip:
            "Verschlüsseln Sie den Rettungsschlüssel im Ruhezustand mit einer Passphrase. Sie benötigen die Passphrase, um ihn in diesem Browser zu entsperren.",
        set_rescue_passphrase_prompt:
            "Geben Sie eine Passphrase ein, um Ihren Rettungsschlüssel im Ruhezustand zu verschlüsseln.\n\nWARNUNG: Wenn Sie diese Passphrase vergessen und keine Sicherung des Rettungsschlüssels haben, sind Ihre Gelder unwiederbringlich verloren.",
        confirm_rescue_passphrase_prompt:
            "Geben Sie die Passphrase zur Bestätigung erneut ein:",
        rescue_passphrase_empty: "Die Passphrase darf nicht leer sein.",
        rescue_passphrase_mismatch:
            "Die Passphrasen stimmen nicht überein. Bitte versuchen Sie es erneut.",
        encrypt_rescue_key_success:
            "Rettungsschlüssel erfolgreich verschlüsselt!",
        encrypt_rescue_key_error:
            "Beim Verschlüsseln des Rettungsschlüssels ist ein Fehler aufgetreten.\n\nFehler: {{ error }}",
        disable_rescue_encryption_prompt:
            "Passphrase-Verschlüsselung entfernen und den Rettungsschlüssel wieder im Klartext speichern?\n\nGeben Sie 'confirm' ein, um fortzufahren:",
        disable_rescue_encryption_success: "Verschlüsselung entfernt.",
        unlock_rescue_key_title: "Rettungsschlüssel entsperren",
        unlock_rescue_key_description:
            "Ihr Rettungsschlüssel ist verschlüsselt. Geben Sie Ihre Passphrase ein, um ihn zu entsperren und fortzufahren.",
        unlock_rescue_key_placeholder: "Passphrase",
        unlock_rescue_key_button: "Entsperren",
        unlock_rescue_key_invalid:
            "Ungültige Passphrase. Bitte versuchen Sie es erneut.",
        no_swaps_found: "Keine Swaps gefunden",
        rif_extra_fee:
            "Wallet enthält nicht genug RBTC, Gebühr um RIF-Relay-Gebühr angepasst!",
        back: "Zurück",
        next: "Weiter",
        pagination_info: "Seite {{ start }} von {{ end }}",
        generate_key: "Neuen Schlüssel generieren",
        show_rescue_key_instead:
            "Stattdessen den 12-Wort-Rettungsschlüssel anzeigen",
        backup_boltz_rescue_key: "SATS Routing Rettungsschlüssel sichern",
        backup_boltz_rescue_key_subline_second:
            "Dieser neue Schlüssel funktioniert auf jedem Gerät und ist für alle Swaps gültig.",
        backup_boltz_rescue_key_subline_third:
            "Bitte schreibe diesen Schlüssel auf oder kopiere ihn und speichere ihn an einem sicheren und dauerhaften Ort.",
        backup_boltz_rescue_key_reminder:
            "Speichere diesen Schlüssel sicher ab. Teile ihn nicht.",
        copy_rescue_key: "Rettungsschlüssel kopieren",
        user_saved_key: "Ich habe den Rettungsschlüssel gespeichert",
        verify_mnemonic_word: {
            start: "Was ist das Wort auf ",
            strong: "Position {{ number }}",
            end: " deines Rettungsschlüssels?",
        },
        incorrect_word:
            "Wort inkorrekt. Bitte überprüfe deinen Rettungsschlüssel.",
        enter_mnemonic: "Rettungsschlüssel eingeben",
        verify_boltz_rescue_key_mnemonic:
            "Bitte gib deinen Rettungsschlüssel unten ein, um ihn zu importieren.",
        hint_paste_mnemonic:
            "Tipp: du kannst alle 12 Wörter gleichzeitig einfügen.",
        swap_opportunities: "Verfügbare Pro-Optionen",
        swap_opportunities_subline:
            "Verdiene Sats oder erhalte einen Rabatt für diese Paare",
        pro_fee: "Progebühr",
        regular_fee: "Normale Gebühr",
        swap_opportunities_accordion: "Pro-Optionen",
        no_opportunities_found: {
            text: "Aktuell keine Pro-Optionen verfügbar. Versuche es später noch einmal.",
            telegram_bot_text_prefix:
                "Für Benachrichtigungen über Progebührenupdates, nutze unseren ",
            telegram_bot_text_middle: " oder ",
            telegram_bot_text_suffix: " bot.",
            telegram_bot: "Telegram",
            simplex: "SimpleX",
        },
        refresh_for_refund:
            "Falls du Bitcoin in diesen Swap gesendet hast, aktualisiere die Seite um eine Rückerstattung zu prüfen.",
        applied_routing_hint:
            "Dein Empfänger unterstützt den direkten Empfang von {{ asset }}. So sparst du Gebühren und der Empfänger bekommt weiterhin den vollen Betrag.",
        optimized_route_amount:
            "Swap-Route optimiert, du sparst ~{{ amount }} {{ denomination }}",
        claim: "Claimen",
        claimed: "Swap wurde erfolgreich geclaimt!",
        rescue: "Retten",
        rescue_swaps: "Swaps retten",
        rescue_swap: "Swap retten",
        failed_get_swap: "Swap {{ id }} konnte nicht abgerufen werden",
        failed_get_swap_subline:
            "Bitte gebe den Rettungsschlüssel erneut ein und versuche es noch einmal.",
        in_progress: "In Bearbeitung",
        completed: "Abgeschlossen",
        get_refundable_error:
            "UTXO-Daten konnten nicht geladen werden. Aktualisiere die Seite um es erneut zu versuchen oder überprüfe deine Internetverbindung, falls das Problem weiterhin besteht.",
        min_amount_destination:
            "Mindestbetrag für die Zieladresse ist {{ amount }} {{ denomination }}",
        max_amount_destination:
            "Höchstbetrag für die Zieladresse ist {{ amount }} {{ denomination }}",
        exact_amount_destination:
            "Betrag muss genau {{ amount }} {{ denomination }} sein",
        destination: "Zieladresse",
        destination_address: "{{ address }}",

        // Products page
        products: "Produkte",
        products_description:
            "Eine Produktsuite für nahtlose Interoperabilität zwischen Bitcoin-Layern",
        products_plugin_title: "SATS Routing BTCPay Plugin",
        products_plugin_description:
            "Eine Lösung um Lightning-Zahlungen non-custodial und einfach zu akzeptieren",
        products_client_title: "SATS Routing Client",
        products_client_description:
            "Unsere Enterpriselösung für Serverintegrationen und Liquiditätsverwaltung",
        products_pro_title: "SATS Routing Pro",
        products_pro_description:
            "Eine Plattform, die es ermöglicht mit Swaps Sats zu verdienen",
        learn_more: "Mehr erfahren",
        get_started: "Öffne SATS Routing Pro",
        documentation: "Dokumentation",
        view_on_github: "Auf Github ansehen",
        chat_with_us: "Chatte mit uns",

        // Plugin
        boltz_plugin_name: "SATS Routing BTCPay Plugin",
        boltz_plugin_description:
            "Non-custodial Lösung für einfache Akzeptierung von Lightning-Zahlungen",
        boltz_plugin_step_install_title: "Plugin hinzufügen",
        boltz_plugin_step_install_description:
            "Installiere das SATS Routing Plugin auf deinem BTCPay Server",
        boltz_plugin_step_setup_title: "Wallet einrichten",
        boltz_plugin_step_setup_description:
            "Verbinde dein externes Wallet oder erstelle ein neues",
        boltz_plugin_step_paid_title: "Lightning akzeptieren",
        boltz_plugin_step_paid_description:
            "Empfange Lightning-Zahlungen und settle automatisch auf Bitcoin",
        boltz_plugin_features_title: "Was sind die Vorteile?",
        boltz_plugin_features_description:
            "Gebaut für Händler die volle Kontrolle ohne Komplexität wollen",
        boltz_plugin_feature_flexible_title: "Flexibel",
        boltz_plugin_feature_flexible_description:
            "Akzeptiere Lightning-Zahlungen non-custodial ohne einen Knoten zu betreiben oder verwalte die Liquidität eines bestehenden Lightning-Knotens",
        boltz_plugin_feature_liquid_title: "Powered by Liquid",
        boltz_plugin_feature_liquid_description:
            "Nutze die volle Power von Liquid Taproot Swaps für niedrige Gebühren und erhöhte Privatsphäre",
        boltz_plugin_feature_autoswap_title: "Settle auf Bitcoin",
        boltz_plugin_feature_autoswap_description:
            "Autoswap zu Bitcoin basierend auf deinen Präferenzen",
        boltz_plugin_feature_self_custodial_title: "Non-custodial",
        boltz_plugin_feature_self_custodial_description:
            "Behalte jederzeit die volle Kontrolle über deine Bitcoin, powered by SATS Routing Atomic Swaps",
        boltz_plugin_questions_title: "Fragen?",
        boltz_plugin_questions_subtitle: "Wir würden gerne von dir hören!",
        // Client
        boltz_client_name: "SATS Routing Client",
        boltz_client_description:
            "Enterprise-Grade Swap-Daemon für Serverintegrationen und Liquiditätsverwaltung",
        boltz_client_features_title: "Gebaut für Unternehmen und Profis",
        boltz_client_features_description:
            "Leistungsstarke Features für professionelle Lightning-Knoten-Betreiber",
        boltz_client_feature_taproot_title: "Taproot-First",
        boltz_client_feature_taproot_description:
            "Nutzt Taproot Swaps für erhöhte Effizienz und Privatsphäre",
        boltz_client_node_agnostic_title: "Knoten-Agnostisch",
        boltz_client_node_agnostic_description:
            "Erstklassige Unterstützung für CLN zusätzlich zu LND, gibt dir Flexibilität in deiner Infrastruktur",
        boltz_client_autoswap_title: "Intelligenter Autoswap",
        boltz_client_autoswap_description:
            "Granulare Kontrolle für automatisches Channel-Rebalancing mit anpassbaren Einstellungen und intelligentem Settlement auf Bitcoin",
        boltz_client_liquid_title: "Liquid-First",
        boltz_client_liquid_description:
            "Optimiert für Channel-Rebalancing mit Liquid-Swaps für niedrige Gebühren, schnelle Ausführung und erhöhte Privatsphäre",
        boltz_client_cli_title: "Leistungsstarke API & CLI",
        boltz_client_cli_first_paragraph:
            "Integriertes Wallet-System und umfassende API für nahtlose Integration in deine Infrastruktur.",
        boltz_client_cli_second_paragraph:
            "Überwache, steuere und automatisiere mit deinen eigenen Anwendungen oder via CLI.",
        boltz_client_cta_title: "Füge SATS Routing deiner Infrastruktur hinzu!",
        boltz_client_cta_subtitle:
            "Werde Teil der Community von Unternehmen und Node-Betreibern, die SATS Routing Client benutzen",

        // Pro
        boltz_pro_name: "SATS Routing Pro",
        boltz_pro_description:
            "Eine Plattform, die es ermöglicht mit Swaps Sats zu verdienen",
        boltz_pro_how_it_works_title: "Wie es funktioniert",
        boltz_pro_how_it_works_description:
            "Du wirst bezahlt für Swaps in Richtungen die uns helfen unsere Liquidität auszugleichen",
        boltz_pro_chart_title: "SATS Routing Pro Gebührenverlauf Beispiel",
        boltz_pro_chart_y_axis: "SATS Routing Pro Gebühr",
        boltz_pro_chart_x_axis: "Datum",
        boltz_pro_negative_fee: "Du verdienst Sats",
        boltz_pro_lower_fee: "Du sparst Sats",
        boltz_pro_regular_fee: "Normale SATS Routing Gebühr",
        boltz_pro_target_audience_title: "Für wen ist SATS Routing Pro?",
        boltz_pro_target_audience_subtitle:
            "Gebaut für Profis die Sats verdienen wollen, nicht für alltägliche Zahlungen",
        boltz_pro_perfect_for_title: "Gebaut für",
        boltz_pro_perfect_for_1:
            "Lightning-Knoten-Betreiber die überschüssige Inbound-Liquidität reduzieren wollen um Sats zu verdienen",
        boltz_pro_perfect_for_2:
            "Profis die mit externen Knoten-Betreibern zusammenarbeiten um Liquidität zu verwalten",
        boltz_pro_perfect_for_3:
            "Nutzer die Lightning-Wallets innerhalb von SATS Routing Pro Routing-Limits aufladen wollen",
        boltz_pro_not_designed_for_title: "Nicht geeignet für",
        boltz_pro_not_designed_for_1:
            "Zahlung mit Lightning im Alltag, wie z.B. im Café",
        boltz_pro_not_designed_for_2:
            "Zuverlässige Zahlungen an Ziele mit hohen Routing-Gebühren",
        boltz_pro_not_designed_for_3:
            "Szenarien die garantierte sofortige Zahlungsausführung erfordern",
        boltz_pro_cta_title: "Fange jetzt an Sats zu verdienen!",
        boltz_pro_cta_subtitle:
            "Schaue dir die aktuellen Möglichkeiten Sats zu verdienen an",
        boltz_pro_options_title: "3 Wege SATS Routing Pro zu nutzen",
        boltz_pro_options_subtitle: "Wähle was am besten zu dir passt",
        boltz_pro_option_client_title: "SATS Routing Client",
        boltz_pro_option_client_description:
            "Automatisiere SATS Routing Pro vollständig mit API & CLI",
        boltz_pro_option_web_title: "Web App",
        boltz_pro_option_web_description:
            "Beobachte und swappe mit unserer SATS Routing Pro Web App",
        boltz_pro_option_chat_title: "Chat-Bots",
        boltz_pro_option_chat_description_prefix:
            "Erhalte Benachrichtigungen in",
        boltz_pro_option_chat_description_middle: "oder",
        boltz_pro_option_chat_description_suffix: ".",

        balance: "Guthaben",
        display: "Anzeige",
        security: "Sicherheit",
        failed: "Fehlgeschlagen",
        swaps_found: "Scanne Swaps ({{ count }} gefunden)",
        claim_scan_required:
            "Um diesen Swap zu claimen, gehe zurück und scanne mit hochgeladener Rescue-Datei.",
        refund_scan_required:
            "Um dieses Guthaben zu erstatten, gehe zurück und scanne mit hochgeladener Rescue-Datei.",
        refund_destination_hint:
            "Das Guthaben wird als {{ symbol }} auf {{ network }} an dein verbundenes EVM-Wallet erstattet.",
        invalid_rescue_key_evm:
            "Dieser Rettungsschlüssel ist nicht mit diesem Swap verbunden. Bitte versuche es erneut mit einem anderen Rettungsschlüssel.",
        error_occurred: "Ein Fehler ist aufgetreten: {{ error }}",
        rescue_external_select_method:
            "Mindestens eine Rettungsmethode auswählen",
        rescue_external_subtitle:
            "Nutze diese Seite, um Swaps zu retten, die nicht im Historie-Tab verfügbar sind.",
        rescue_external_report_issue_start:
            "Wenn du denkst, dass dein Swap aufgrund eines Fehlers auf unserer Seite fehlgeschlagen ist, klicke bitte ",
        rescue_external_report_issue_link: "hier",
        rescue_external_report_issue_end:
            ", um Logs zu teilen und uns einige Details zu deinem Swap mitzuteilen.",
        rescue_external_coverage:
            "Rettbar mit den bereitgestellten Rettungsmethoden",
        rescue_external_requires_rescue_key: "Benötigt Rettungsschlüssel",
        rescue_external_requires_wallet: "Benötigt Wallet",
        rescue_external_requires_rescue_key_wallet:
            "Benötigt Rettungsschlüssel und Wallet",
        rescue_external_resume: "Fortsetzen",
        evm_rescue_prompt:
            'Wenn du Guthaben in einen SATS Routing-Swap auf einer EVM-Chain gesendet hast, nutze "Swap erstatten"; wenn du Guthaben von einer EVM-Chain empfangen hast, nutze "Swap fortsetzen", um einen Swap zu retten, der nicht im Verlauf dieses Browsers verfügbar ist.',
        evm_rescue_refund_title: "Swap erstatten",
        start_scanning: "Scannen starten",
        stop_scanning: "Scannen stoppen",
        evm_rescue_resume_title: "Swap fortsetzen",
        evm_rescue_resume_explainer:
            "Nutze deinen Rettungsschlüssel, um ausstehende Swaps zu finden, die fortgesetzt werden können.",
        unmatched_swaps:
            "Dieses Wallet hat {{ count }} zusätzliche claimbare Swaps. Um darauf zuzugreifen, wechsle bitte zu dem Rettungsschlüssel, mit dem diese Swaps gestartet wurden.",
        approve: "Freigeben",
        approve_allowance_line:
            "{{ tokenStandard }}-Freigabe für den Swap-Contract festlegen",
        approve_allowance_reset_line:
            "Einige {{ tokenStandard }}-Token verlangen, dass die Freigabe zuerst auf 0 gesetzt wird, bevor ein neuer Betrag gesetzt werden kann. Möglicherweise musst du zweimal freigeben.",
        upload_rescue_key: "Rettungsschlüssel auswählen",

        suspension_status: "Swap-Dienste deaktiviert",
        suspension_p1: "Update: SATS Routing bleibt bis auf Weiteres deaktiviert.",
        suspension_p2:
            "Unsere API bleibt verfügbar, um Erstattungen kooperativ abzuwickeln. In jedem Fall funktionieren einseitige Erstattungen, da sie nicht von unserer Infrastruktur abhängen.",
        suspension_p3: "Unser Support-Team bleibt erreichbar.",
        suspension_p4:
            "Um es klar zu sagen: Dies ist keine Reaktion auf einen einzelnen Vorfall. In den vergangenen Monaten haben wir einen stetigen Anstieg automatisierter, KI-gestützter Angriffsversuche auf unsere Infrastruktur beobachtet und mehrere Exploits bewältigt. Jeder davon wurde eingedämmt, aber das Muster ist eindeutig: Angreifer iterieren inzwischen schneller, als ein Team unserer Größe Lücken finden und schließen kann. Allein in den letzten Tagen haben wir eine drastische Beschleunigung gesehen, und wir glauben nicht, dass sich diese Asymmetrie umkehren wird. Nach Auswertung unserer eigenen jüngsten Sicherheitsscans können wir SATS Routing-Swaps nicht verantwortungsvoll wieder aktivieren, zumal wir aktiv von offenbar mehreren gut ausgestatteten Gruppen ins Visier genommen werden, während wir mit Hochdruck an Fixes arbeiten.",
        suspension_p5:
            "Was wir hier sehen, ist ein grundlegender Paradigmenwechsel für Bitcoin-Dienste, die auf einem Open-Source-Stack laufen, und er erfordert eine sorgfältige Analyse. Erwarte nicht, dass die Swap-Dienste in Kürze zurückkehren.",
        suspension_p6:
            "Um es deutlich zu sagen: Nutzergelder waren zu keinem Zeitpunkt in Gefahr. SATS Routing ist von Grund auf non-custodial. Und da wir ein vollständig eigenfinanziertes Unternehmen sind, waren die Verluste allein unsere.",
        suspension_p7:
            "Wir wissen noch nicht, wie es von hier aus weitergeht, aber wir halten dich auf dem Laufenden, sobald wir Zeit hatten durchzuatmen und eine Entscheidung zu treffen 🙏",
        suspension_date: "3. August 2026 · Auf X ansehen",
    },
    es: {
        language: "Español",
        or: "o",
        status: "Estado",
        fast: "Rápido",
        l2: "Construido en la Capa 2",
        l2_sub: "SATS Routing utiliza tecnologías de segunda capa como la red de Lightning",
        assets_sub: "Capas de Bitcoin",
        safe: "Seguro",
        non_custodial: "Sin Custodia",
        non_custodial_sub:
            "Los intercambios en SATS Routing son atomicos, la criptografía garantiza que los usuarios siempre tienen el control de su Bitcoin",
        node: "Nodos de Lightning",
        error: "Error",
        error_subline: "Respuesta inválida de la API, algo está mal :/",
        error_wasm: "WebAssembly no soportado",
        history: "Historia",
        swap: "Intercambio",
        refund: "Reembolso",
        partner: "Socio",
        support: "Ayuda",
        docs: "Docs",
        onion: "Onion",
        terms: "Términos",
        privacy: "Privacidad",
        blockexplorer: "Ver en {{ typeLabel }}",
        blockexplorer_lockup_address: "Dirección Lockup",
        blockexplorer_lockup_tx: "Transacción de Lockup",
        blockexplorer_claim_tx: "Transacción de Reclamación",
        blockexplorer_refund_tx: "Transacción de Reembolso",
        check_bridge_status: "Comprobar estado del puente",
        help: "Ayuda",
        network_fee: "Comisión de Red",
        swap_fees: "Comisiones del Intercambio",
        fee: "Comisión de SATS Routing",
        denomination: "Denominación",
        send: "Enviar",
        checking_previous_transaction: "Comprobando transacción anterior",
        checking_previous_transaction_line:
            "Espera mientras comprobamos si tu billetera envió la transacción de puente.",
        could_not_confirm_previous_transaction:
            "No se pudo confirmar la transacción anterior",
        could_not_confirm_previous_transaction_line:
            "No pudimos confirmar si tu billetera envió la transacción de puente.",
        checking_previous_transaction_countdown:
            "Quedan {{ seconds }} segundos.",
        check_again: "Comprobar de nuevo",
        did_not_send_transaction: "No envié una transacción",
        did_not_send_transaction_confirm:
            "Continúa solo si tienes la certeza de que tu billetera no envió la transacción. Continuar puede hacer que envíes fondos dos veces.",
        continue: "Continuar",
        receive: "Recibir",
        max: "Máx",
        minimum_amount: "La cantidad mínima es {{ amount }} {{ denomination }}",
        maximum_amount: "La cantidad máxima es {{ amount }} {{ denomination }}",
        assets: "Multicapa",
        footer: "Hecho con 🧡 por SATS Routing",
        create_swap: "Crear intercambio",
        get_gas_token_for_gas: "Obtén {{ gasToken }} para gas",
        new_swap: "Nuevo intercambio",
        feecheck:
            "La comisión de red se actualizó según la situación de la red. Por favor, confirma los nuevos importes y continúa con el intercambio.",
        amount_limits_changed:
            "Los límites del intercambio han cambiado. Por favor, confirma los nuevos importes y continúa con el intercambio.",
        commitment_invoice_heading:
            "Introduce una factura Lightning por {{ amount }} {{ denomination }}",
        commitment_invoice_deferred:
            "Ingresa el destino Lightning después del pago",
        clear_amount: "Borrar",
        create_and_paste:
            "Pega una factura Lightning, una dirección BOLT12 o una LNURL para recibir los fondos",
        invoice_cleared_amount_changed:
            "La factura se borró porque cambió el importe.",
        congrats: "¡Felicitaciones!",
        successfully_swapped:
            "Has recibido con éxito {{ amount }} {{ denomination }}!",
        bridge_transfer_pending:
            "¡Intercambio completado! Tus {{ amount }} {{ denomination }} se enviaron a través del puente {{ network }}. Las transferencias por puentes pueden tardar unos minutos en finalizar.",
        timeout_eta: "Tiempo de espera estimado",
        pay_invoice: "Intercambio: {{ id }}",
        pay_swap_404: "¡Intercambio no encontrado!",
        pay_timeout_blockheight:
            "Altura del bloque de tiempo de espera ({{ network }})",
        send_to: "Enviar {{ amount }} {{ denomination }} a",
        send_between: "Enviar entre {{ min }} y {{ max }} {{ denomination }} a",
        pay_invoice_to: "Pague esta factura de {{ amount }} {{ denomination }}",
        no_wallet: "Monedero no está instalado",
        connect_wallet: "Conectar monedero",
        please_connect_wallet: "Por favor, conecte monedero",
        connect_to_address: "Conectar con dirección de intercambio",
        disconnect_address: "Desconectar monedero",
        lockup_failed: "Fallo en el lockup",
        failure_reason: "Motivo del fallo",
        invoice_payment_failure: "No se pudo pagar tu factura Lightning",
        onchain_address:
            "Ingrese una dirección {{ asset }} para recibir los fondos",
        onchain_address_no_asset: "Ingrese la dirección",
        invalid_refund_file: "Clave de rescate no válido",
        invalid_invoice:
            "Por favor, pegue una factura Lightning, BOLT12 o LNURL válida",
        invalid_0_amount: "No se admiten facturas sin importe",
        copy_invoice: "Factura Lightning",
        copy_address: "Dirección",
        copy_amount: "Importe",
        copy_bip21: "BIP21",
        rescue_a_swap_subline:
            "Si enviaste BTC o LBTC a un intercambio SATS Routing, carga o introduce tu clave de rescate para rescatar un swap que no esté disponible en el historial de swaps de este navegador",
        rescue_a_swap_mnemonic:
            "Introduce tu clave de rescate para rescatar un intercambio que no está disponible en el historial de este navegador.",
        refund_past_swaps: "Intercambios anteriores",
        refund_past_swaps_subline:
            "Intercambios que se guardaron en el almacenamiento del navegador",
        no_rescuable_swaps:
            "No se han encontrado intercambios rescatables en el historial de tu navegador",
        refund_external_scanning_evm:
            "Escaneando en busca de intercambios rescatables en cadenas EVM...",
        connected_wallet_no_swaps:
            "El monedero Rootstock conectado no contiene ningún intercambio rescatable.",
        history_no_swaps: "Parece que aún no has realizado ningún intercambio.",
        refund_address_header:
            "Introduce la dirección de tu monedero {{ asset }} para reembolsar",
        refund_address_header_no_asset:
            "Introduce la dirección de tu monedero para reembolsar",
        history_export: "Exportar",
        refund_clear: "Borrar almacenamiento",
        delete_storage:
            "¿Estás seguro de que deseas borrar tu almacenamiento?\nSe perderán la información de tu intercambio y tus claves de reembolso.",
        delete_storage_single_swap:
            "¿Estás seguro de que deseas borrar el intercambio {{ id }} de tu almacenamiento?\nSe perderán la información de tu intercambio y tus claves privadas de reembolso.",
        delete_logs: "¿Estás seguro de que deseas borrar tus registros?",
        tx_in_mempool: "La transacción está en el mempool.",
        tx_in_mempool_subline:
            "Esperando confirmación para completar el intercambio.",
        tx_in_mempool_warning:
            "Mantenga la página abierta, o el intercambio no se completará!",
        invoice_pending: "Transacción recibida, pagando la factura...",
        invoice_pending_pro:
            "Transacción recibida, factura en cola. En algunas ocasiones, el intercambio podría ser cancelado.",
        invoice_expired: "La factura ha expirado, ¡intente nuevamente!",
        create_invoice_webln: "Crear factura a través de WebLN",
        pay_invoice_webln: "Pagar factura a través de WebLN",
        select_asset_send: "Seleccionar activo a enviar",
        select_asset_receive: "Seleccionar activo a recibir",
        select_network: "Seleccionar red",
        search: "Buscar",
        tx_confirmed: "Transacción confirmada!",
        tx_ready_to_claim: "Reclamando la transacción ahora...",
        refunded: "El intercambio ha sido reembolsado!",
        refunded_bridge_pending:
            "El intercambio ha sido reembolsado. Tu {{ denomination }} se está puenteando de vuelta a {{ network }} y puede tardar algún tiempo en llegar.",
        locktime_not_satisfied:
            "No se cumple el requisito de tiempo de bloqueo!",
        already_refunded: "El intercambio ya ha sido reembolsado!",
        api_offline: "API está offline!",
        api_offline_msg:
            "No se pudo conectar a la API de SATS Routing, por favor inténtelo de nuevo más tarde!",
        refund_explainer:
            "Podrás solicitar un reembolso después del tiempo de espera!",
        wasm_not_supported: "Por favor, activa WebAssembly en tu navegador!",
        created: "Creado",
        view: "Ver",
        id: "ID",
        headline: "Bitcoin Bridge Sin Custodia",
        headline_pro: "Apilar Sats Con Autocustodia",
        subline:
            "Intercambia entre diferentes capas de Bitcoin mientras mantienes el control total.",
        subline_pro:
            "Gana sats por intercambiar Bitcoin en direcciones que ayudan a equilibrar nuestra liquidez.",
        start_swapping: "Comenzar a intercambiar",
        partners: "Socios",
        integrations: "Integraciones",
        oldest_channel_years: "{{ years }} años",
        oldest_channel: "Canal más antiguo",
        capacity: "Capacidad ({{ denomination }})",
        peers: "Número de peers",
        num_channels: "Número de canales",
        beta_caution: "BETA - ¡ÚSALO CON PRECAUCIÓN!",
        pro: "pro",
        pro_banner: "¿Quieres usar SATS Routing Pro a través de la API?",
        warning_return:
            "Regresa a esta página después de pagar la factura! El pago puede aparecer como pendiente hasta que vuelvas a esta página.",
        warning_expiry:
            "Importante: Asegúrate de que la transacción se confirme en ~24 horas",
        not_found: "404 - Not Found",
        not_found_subline: "Esta página parece haber desaparecido.",
        back_to_home: "Volver al inicio",
        transaction_prompt:
            'Pulse "{{ button }}" para abrir tu monedero conectado y confirmar la transacción mostrada.',
        transaction_prompt_receive:
            'Pulse "{{ button }}" para comenzar a reclamar {{ asset }}.',
        transaction_failed: "Transacción fallida: {{ error }}",
        wallet_request_rejected: "La solicitud fue rechazada en tu monedero.",
        invalid_address: "Dirección {{ asset }} inválida",
        scan_qr_code: "Escanear código QR",
        version: "Versión",
        commithash: "Commit Hash",
        open_in_wallet: "Abrir en monedero",
        branding: "Branding",
        regtest: "Regtest",
        broadcasting_claim: "Enviando transacción de reclamación...",
        paste_invalid:
            "El portapapeles contiene caracteres no válidos o se ha excedido el importe máximo",
        email: "Email",
        switch_paste:
            "Cambiado de dirección/activo de intercambio basado en el contenido pegado",
        settings: "Ajustes",
        decimal_separator: "Separador decimal",
        denomination_tooltip: "Elige tu denominación preferida: BTC o sats",
        decimal_tooltip: "Elige tu separador decimal preferido: punto o coma",
        fiat_rate_not_available: "Tasa fiat no disponible",
        fiat_currency: "Moneda fiat",
        fiat_currency_tooltip:
            "Moneda utilizada para mostrar el equivalente fiat",
        swap_completed: "¡Intercambio {{ id }} completado con éxito!",
        claim_fail: "¡Error en reclamar el intercambio {{ id }}!",
        logs: "Logs",
        logs_tooltip:
            "Registros de la aplicación web como herramienta de depuración",
        share_with_support: "Compartir con soporte",
        chatwoot_not_ready:
            "El chat de soporte se está abriendo — por favor, intenta compartir tus logs de nuevo cuando haya cargado.",
        hide_wallet_address: "Modo de Privacidad",
        hide_wallet_address_tooltip:
            "Oculta la dirección del monedero EVM y el ID de Swap para privacidad en demos y grabaciones",
        bitcoin_only: "Modo Bitcoin-Only",
        bitcoin_only_tooltip:
            "Mostrar solo Bitcoin y Lightning, ocultando todos los demás pares",
        bitcoin_only_warning:
            "Modo Bitcoin-Only está activado. Desactívalo en los ajustes para intercambiar otros activos.",
        slippage: "Slippage",
        slippage_tooltip: "Tolerancia máxima de slippage para swaps en DEX",
        gas_topup: "Recarga automática de gas",
        gas_topup_tooltip:
            "Convierte automáticamente una pequeña parte de tu swap en gas nativo si tu monedero conectado no tiene gas.",
        gas_topup_label: "Gas de destino ({{ gasToken }}) incluido",
        bridge_messaging_fee: "Tarifa de Mensajería del Puente",
        bridge_transfer_fee: "Tarifa de Transferencia del Puente",
        retry: "Reintentar",
        error_bridge_capacity: "La cantidad excede la capacidad del puente",
        error_no_quote:
            "No se pudo obtener una cotización. Por favor, verifique su conexión e inténtelo de nuevo.",
        error_zero_quote: "Aumenta la cantidad a enviar",
        oft_eta: "Llegada estimada en aproximadamente {{ time }}",
        oft_eta_day_unit: "{{ value }}d",
        oft_eta_hour_unit: "{{ value }}h",
        oft_eta_minute_unit: "{{ value }}min",
        oft_eta_second_unit: "{{ value }}s",
        oft_arriving_soon: "Llegando pronto...",
        oft_transfer_in_progress: "Transferencia en curso",
        waiting_for_bridge: "Esperando el puente {{ symbol }}",
        dex_quote_changed: "La cotización de DEX ha cambiado",
        commitment_rejected_line:
            "El monto enviado se quedó corto, por lo que este intercambio no se puede completar. Puedes reembolsar tus fondos a tu dirección original.",
        pre_bridge_dex_quote_blocked: "La cotización ha cambiado",
        pre_bridge_dex_quote_blocked_line:
            "Los precios cambiaron mientras tus fondos se transferían por el puente, por lo que la cotización ya no es suficiente para completar el swap. Inténtalo de nuevo o reembolsa tus fondos.",
        recovering_bridged_funds: "Reembolsando...",
        pre_bridge_refund_initiated:
            "Tus fondos se están enviando de vuelta a tu dirección original a través del puente y llegarán en breve.",
        retry_quote: "Reintentar",
        retrying_quote: "Comprobando cotización...",
        zero_conf: "Zero-Conf",
        zero_conf_tooltip:
            "Aceptar transacciones que aún no están confirmadas en un bloque",
        on: "on",
        off: "off",
        invalid_pair: "Par no válido",
        invalid_send_asset: "Activo de envío no válido",
        error_starting_qr_scanner:
            "No se pudo acceder a la cámara, por favor comprueba los permisos!",
        insufficient_balance: "Saldo insuficiente",
        insufficient_balance_line:
            "No tienes saldo suficiente en tu monedero para este swap.",
        insufficient_gas_balance_line:
            "No tienes suficiente {{ gasToken }} para financiar el swap.",
        select_wallet: "Seleccionar monedero",
        select_derivation_path: "Seleccionar ruta de derivación",
        submit_derivation_path: "Enviar",
        not_supported_in_browser: "No compatible con este navegador",
        switch_network: "Cambiar red",
        block: "bloque",
        logs_scan_progress: "Progreso del escaneo {{ value }}%",
        logs_deriving_keys: "Derivando claves... ({{ count }} hasta ahora)",
        accept: "Aceptar",
        wallet_connect_failed: "Fallo en la conexión del monedero: {{ error }}",
        ledger_open_app_prompt: "Abrir aplicación Ethereum o RSK",
        validate_payment: "Mostrar justificante de pago",
        no_browser_wallet: "No se detectó monedero en el navegador",
        sent: "Enviado",
        will_receive: "Recibirá",
        refund_available_in: "Reembolso disponible en {{ blocks }} bloques",
        no_wallet_connected: "No hay monedero conectado",
        no_lockup_transaction: "No se encontró ninguna transacción de lockup",
        routing_fee_limit: "Límite Comisión Enrutamiento",
        download_boltz_rescue_key: "Clave de rescate SATS Routing",
        download_boltz_rescue_key_subline:
            "Haz una copia de seguridad de todos tus intercambios con una sola clave de rescate 🙌",
        download_boltz_rescue_key_subline_second:
            "Esta clave funciona en cualquier dispositivo y para todos los intercambios creados con ella.",
        download_boltz_rescue_key_subline_backup:
            "Para continuar, haz una copia de seguridad.",
        download_boltz_rescue_key_subline_privacy:
            "**Cuidado:** Los navegadores centrados en la privacidad pueden eliminar los archivos descargados al cerrarse.",
        download_boltz_rescue_key_subline_save:
            "¡Guarda la clave de rescate en un lugar **SEGURO** y **PERMANENTE**!",
        download_boltz_rescue_key_subline_warning:
            "No hacerlo puede provocar una **PÉRDIDA DE FONDOS**.",
        download_new_key: "Descargar clave de rescate",
        verify_boltz_rescue_key: "Verificar clave de rescate existente",
        verify_boltz_rescue_key_subline:
            "Por favor, selecciona tu clave de rescate SATS Routing previamente guardada para verificar su validez.",
        verify_key: "Verificar clave",
        verify_key_failed:
            "La verificación de la clave de rescate SATS Routing ha fallado. Recomendamos descargar una nueva clave para continuar.",
        rescue_key: "Clave de Rescate SATS Routing",
        reset_rescue_key_tooltip:
            "Generar una nueva clave de rescate y borrar todos los datos de intercambios históricos",
        reset_rescue_key_prompt:
            "⚠️ ADVERTENCIA: Esto eliminará TODOS tus datos de intercambios y generará una nueva clave de rescate.\n\nNo continúes a menos que tengas una copia de seguridad de tu clave de rescate existente o estés absolutamente seguro de que no la necesitarás.\n\nEscribe 'confirm' para continuar:",
        reset_rescue_key_invalid_confirmation:
            "Confirmación no válida. Por favor, escribe 'confirm' para continuar.",
        reset_rescue_key_error:
            "Ocurrió un error al restablecer la clave de rescate. Por favor, intente de nuevo.\n\nError: {{ error }}",
        reset_rescue_key_success: "¡Nueva clave de rescate generada con éxito!",
        encrypt_rescue_key: "Cifrar",
        decrypt_rescue_key: "Quitar cifrado",
        encrypt_rescue_key_tooltip:
            "Cifra la clave de rescate en reposo con una frase de contraseña. Necesitarás la frase de contraseña para desbloquearla en este navegador.",
        set_rescue_passphrase_prompt:
            "Introduce una frase de contraseña para cifrar tu clave de rescate en reposo.\n\nADVERTENCIA: si olvidas esta frase de contraseña y no tienes una copia de seguridad de la clave de rescate, tus fondos serán irrecuperables.",
        confirm_rescue_passphrase_prompt:
            "Vuelve a introducir la frase de contraseña para confirmar:",
        rescue_passphrase_empty:
            "La frase de contraseña no puede estar vacía.",
        rescue_passphrase_mismatch:
            "Las frases de contraseña no coinciden. Inténtalo de nuevo.",
        encrypt_rescue_key_success: "¡Clave de rescate cifrada con éxito!",
        encrypt_rescue_key_error:
            "Ocurrió un error al cifrar la clave de rescate.\n\nError: {{ error }}",
        disable_rescue_encryption_prompt:
            "¿Quitar el cifrado con frase de contraseña y volver a almacenar la clave de rescate en texto plano?\n\nEscribe 'confirm' para continuar:",
        disable_rescue_encryption_success: "Cifrado eliminado.",
        unlock_rescue_key_title: "Desbloquea tu clave de rescate",
        unlock_rescue_key_description:
            "Tu clave de rescate está cifrada. Introduce tu frase de contraseña para desbloquearla y continuar.",
        unlock_rescue_key_placeholder: "Frase de contraseña",
        unlock_rescue_key_button: "Desbloquear",
        unlock_rescue_key_invalid:
            "Frase de contraseña no válida. Inténtalo de nuevo.",
        no_swaps_found: "No se encontraron intercambios",
        rif_extra_fee:
            "El monedero no contiene suficientes RBTC, comisión ajustada para incluir comisión de RIF Relay!",
        back: "Atrás",
        next: "Siguiente",
        pagination_info: "Página {{ start }} de {{ end }}",
        generate_key: "Generar nueva clave",
        show_rescue_key_instead:
            "Mostrar en su lugar la clave de rescate de 12 palabras",
        backup_boltz_rescue_key: "Backup clave de rescate SATS Routing",
        backup_boltz_rescue_key_subline_second:
            "Esta nueva clave funciona en cualquier dispositivo y funciona para todas las transacciones creadas con ella.",
        backup_boltz_rescue_key_subline_third:
            "Por favor, escriba o copie esta clave y almacénela en un lugar seguro y permanente.",
        backup_boltz_rescue_key_reminder:
            "Guarde esta clave con seguridad. No comparta.",
        copy_rescue_key: "Copiar clave de rescate",
        user_saved_key: "He guardado la clave de rescate",
        verify_mnemonic_word: {
            start: "¿Cuál es la palabra en ",
            strong: "la posición {{ number }}",
            end: " de tu clave de rescate?",
        },
        incorrect_word:
            "Palabra incorrecta. Por favor, verifica tu clave de rescate.",
        enter_mnemonic: "Ingrese clave de rescate",
        verify_boltz_rescue_key_mnemonic:
            "Por favor, ingresa tu clave de rescate a continuación para importarla.",
        hint_paste_mnemonic:
            "Consejo: puedes pegar todas las 12 palabras a la vez.",
        swap_opportunities: "Oportunidades Pro Disponibles",
        swap_opportunities_subline:
            "Gana sats o recibe descuentos intercambiando estos pares",
        pro_fee: "Comisión Pro",
        regular_fee: "Comisión Estándar",
        swap_opportunities_accordion: "Oportunidades Pro",
        no_opportunities_found: {
            text: "No hay oportunidades Pro disponibles. Por favor, revisa más tarde.",
            telegram_bot_text_prefix:
                "Para alertas de comisiones, consulta nuestro bot en ",
            telegram_bot_text_middle: " o ",
            telegram_bot_text_suffix: ".",
            telegram_bot: "Telegram",
            simplex: "SimpleX",
        },
        refresh_for_refund:
            "Si has enviado Bitcoin a este intercambio, actualiza la página para comprobar si hay un reembolso disponible.",
        applied_routing_hint:
            "Tu destinatario admite recibir {{ asset }} directamente. Así te ahorras comisiones y ellos siguen recibiendo el importe íntegro.",
        optimized_route_amount:
            "Ruta de intercambio optimizada, ahorrándote ~{{ amount }} {{ denomination }}",
        claim: "Reclamar",
        claimed: "¡El intercambio ha sido reclamado exitosamente!",
        rescue: "Rescatar",
        rescue_swaps: "Rescatar intercambios",
        rescue_swap: "Rescatar Intercambio",
        failed_get_swap: "No se pudo obtener el intercambio {{ id }}",
        failed_get_swap_subline:
            "Por favor, vuelve a introducir la clave de rescate e inténtalo de nuevo.",
        in_progress: "En progreso",
        completed: "Completado",
        get_refundable_error:
            "No se pudieron cargar los datos de UTXO. Actualiza la página para volver a intentarlo o verifica tu conexión a Internet si el problema persiste.",
        min_amount_destination:
            "La cantidad mínima para la dirección de destino es {{ amount }} {{ denomination }}",
        max_amount_destination:
            "La cantidad máxima para la dirección de destino es {{ amount }} {{ denomination }}",
        exact_amount_destination:
            "El importe de la factura debe ser exactamente {{ amount }} {{ denomination }}",
        destination: "Destino",
        destination_address: "{{ address }}",

        // Products page
        products: "Productos",
        products_description:
            "Una suite de productos para interoperabilidad perfecta entre las capas de Bitcoin",
        products_plugin_title: "Plugin SATS Routing BTCPay",
        products_plugin_description:
            "Una solución sin custodia para aceptar fácilmente pagos Lightning sin ejecutar un nodo Lightning",
        products_client_title: "Cliente SATS Routing",
        products_client_description:
            "Daemon de intercambios empresarial para integraciones y gestión de liquidez",
        products_pro_title: "SATS Routing Pro",
        products_pro_description:
            "Una plataforma que permite ganar sats con intercambios",
        learn_more: "Aprende más",
        get_started: "Abrir SATS Routing Pro",
        documentation: "Documentación",
        view_on_github: "Ver en Github",
        chat_with_us: "Chatea con nosotros",

        // Plugin
        boltz_plugin_name: "Plugin SATS Routing BTCPay",
        boltz_plugin_description:
            "Solución sin custodia para aceptar fácilmente pagos Lightning",
        boltz_plugin_step_install_title: "Agregar el plugin",
        boltz_plugin_step_install_description:
            "Instala el plugin SATS Routing en tu servidor BTCPay",
        boltz_plugin_step_setup_title: "Configurar tu monedero",
        boltz_plugin_step_setup_description:
            "Conecta tu monedero externo o crea uno nuevo",
        boltz_plugin_step_paid_title: "Aceptar Lightning",
        boltz_plugin_step_paid_description:
            "Recibe pagos Lightning con liquidación automática en Bitcoin",
        boltz_plugin_features_title: "¿Por qué usarlo?",
        boltz_plugin_features_description:
            "Construido para comerciantes que quieren control sin complejidad",
        boltz_plugin_feature_flexible_title: "Flexible",
        boltz_plugin_feature_flexible_description:
            "Acepta pagos Lightning sin ejecutar un nodo o gestiona completamente la liquidez de un nodo Lightning existente",
        boltz_plugin_feature_liquid_title: "Impulsado por Liquid",
        boltz_plugin_feature_liquid_description:
            "Aprovecha el poder de los Liquid Taproot Swaps para comisiones bajas y mayor privacidad",
        boltz_plugin_feature_autoswap_title: "Liquidar en Bitcoin",
        boltz_plugin_feature_autoswap_description:
            "Autoswap a Bitcoin mainchain basado en tus preferencias",
        boltz_plugin_feature_self_custodial_title: "Sin custodia",
        boltz_plugin_feature_self_custodial_description:
            "Mantén el control total de tus Bitcoin, impulsado por SATS Routing Atomic Swaps",

        boltz_plugin_questions_title: "¿Preguntas?",
        boltz_plugin_questions_subtitle: "¡Nos encantaría escucharte!",
        // Client
        boltz_client_name: "Cliente SATS Routing",
        boltz_client_description:
            "Daemon de intercambios empresarial para integraciones y gestión de liquidez",
        boltz_client_features_title: "Construido para Empresas y Profesionales",
        boltz_client_features_description:
            "Características potentes diseñadas para operadores profesionales de nodos Lightning",
        boltz_client_feature_taproot_title: "Taproot-First",
        boltz_client_feature_taproot_description:
            "Aprovecha los Taproot Swaps para mayor eficiencia y privacidad",
        boltz_client_node_agnostic_title: "Agnóstico de Nodo",
        boltz_client_node_agnostic_description:
            "Soporte de primera clase para CLN además de LND, dándote flexibilidad en tu infraestructura",
        boltz_client_autoswap_title: "Autoswap Inteligente",
        boltz_client_autoswap_description:
            "Control granular para el reequilibrio automático de canales con configuraciones personalizables y liquidación inteligente en Bitcoin",
        boltz_client_liquid_title: "Liquid-First",
        boltz_client_liquid_description:
            "Optimizado para el reequilibrio de canales usando intercambios Liquid para comisiones bajas, ejecución rápida y mayor privacidad",
        boltz_client_cli_title: "API y CLI Potentes",
        boltz_client_cli_first_paragraph:
            "Sistema de monedero integrado y API completa para una integración perfecta en tu infraestructura.",
        boltz_client_cli_second_paragraph:
            "Monitorea, controla y automatiza con tus propias aplicaciones o a través de la CLI.",
        boltz_client_cta_title: "¡Agrega SATS Routing a tu infraestructura!",
        boltz_client_cta_subtitle:
            "Únete a la comunidad de empresas y operadores de nodos que usan SATS Routing Client",

        // Pro
        boltz_pro_name: "SATS Routing Pro",
        boltz_pro_description:
            "Una plataforma que permite ganar sats con intercambios atómicos",
        boltz_pro_how_it_works_title: "Cómo funciona",
        boltz_pro_how_it_works_description:
            "Te pagamos por hacer intercambios en direcciones que nos ayudan a reequilibrar nuestra liquidez",
        boltz_pro_chart_title: "Muestra del Historial de comisiones SATS Routing Pro",
        boltz_pro_chart_y_axis: "Comisión SATS Routing Pro",
        boltz_pro_chart_x_axis: "Fecha",
        boltz_pro_negative_fee: "Ganas sats",
        boltz_pro_lower_fee: "Ahorras sats",
        boltz_pro_regular_fee: "Comisión Regular de SATS Routing",
        boltz_pro_target_audience_title: "¿Para quién es SATS Routing Pro?",
        boltz_pro_target_audience_subtitle:
            "Construido para profesionales que quieren ganar sats, no para pagos cotidianos",
        boltz_pro_perfect_for_title: "Construido Para",
        boltz_pro_perfect_for_1:
            "Operadores de nodos Lightning que buscan reducir el exceso de liquidez entrante para ganar sats",
        boltz_pro_perfect_for_2:
            "Profesionales que colaboran con operadores de nodos externos para gestionar liquidez",
        boltz_pro_perfect_for_3:
            "Usuarios que recargan monederos Lightning dentro de los límites de enrutamiento de SATS Routing Pro",
        boltz_pro_not_designed_for_title: "No Adecuado Para",
        boltz_pro_not_designed_for_1:
            "Pagos Lightning cotidianos, como comprar un café",
        boltz_pro_not_designed_for_2:
            "Pagos confiables a destinos con altas comisiones de enrutamiento",
        boltz_pro_not_designed_for_3:
            "Escenarios que requieren ejecución de pago instantánea garantizada",
        boltz_pro_cta_title: "¡Comienza a ganar sats ahora!",
        boltz_pro_cta_subtitle:
            "Descubre las oportunidades actuales para ganar sats",
        boltz_pro_options_title: "3 formas de usar SATS Routing Pro",
        boltz_pro_options_subtitle: "Elige lo que mejor te convenga",
        boltz_pro_option_client_title: "Cliente SATS Routing",
        boltz_pro_option_client_description:
            "Automatiza SATS Routing Pro completamente con API y CLI",
        boltz_pro_option_web_title: "Aplicación Web",
        boltz_pro_option_web_description:
            "Observa y ejecuta intercambios con nuestra aplicación web",
        boltz_pro_option_chat_title: "Bots de chat",
        boltz_pro_option_chat_description_prefix:
            "Recibe alertas instantáneas en",
        boltz_pro_option_chat_description_middle: "o",
        boltz_pro_option_chat_description_suffix: ".",

        balance: "Saldo",
        display: "Pantalla",
        security: "Seguridad",
        failed: "Fallido",
        swaps_found: "Escaneando intercambios ({{ count }} encontrados)",
        claim_scan_required:
            "Para reclamar este intercambio, vuelve y escanea con tu archivo de rescate cargado.",
        refund_scan_required:
            "Para reembolsar este saldo, vuelve y escanea con tu archivo de rescate cargado.",
        refund_destination_hint:
            "Los fondos se reembolsarán como {{ symbol }} en {{ network }} a tu monedero EVM conectado.",
        invalid_rescue_key_evm:
            "Esta clave de rescate no está asociada con este intercambio. Por favor, intenta de nuevo usando una clave de rescate diferente.",
        error_occurred: "Ocurrió un error: {{ error }}",
        rescue_external_select_method:
            "Selecciona al menos un método de rescate",
        rescue_external_subtitle:
            "Usa esta página para rescatar intercambios que no están disponibles en la pestaña de historia.",
        rescue_external_report_issue_start:
            "Si crees que tu intercambio falló debido a un problema de nuestra parte, por favor ",
        rescue_external_report_issue_link: "haz clic aquí",
        rescue_external_report_issue_end:
            " para compartir los logs y darnos algunos detalles sobre tu intercambio.",
        rescue_external_coverage:
            "Rescatable con los métodos de rescate proporcionados",
        rescue_external_requires_rescue_key: "Requiere clave de rescate",
        rescue_external_requires_wallet: "Requiere monedero",
        rescue_external_requires_rescue_key_wallet:
            "Requiere clave de rescate y monedero",
        rescue_external_resume: "Reanudar",
        evm_rescue_prompt:
            'Si enviaste fondos a un intercambio de SATS Routing en una cadena EVM, usa "Reembolsar intercambio"; si estabas recibiendo fondos desde una cadena EVM, usa "Reanudar intercambio" para rescatar un intercambio que no está disponible en el historial de este navegador.',
        evm_rescue_refund_title: "Reembolsar intercambio",
        start_scanning: "Iniciar escaneo",
        stop_scanning: "Detener escaneo",
        evm_rescue_resume_title: "Reanudar intercambio",
        evm_rescue_resume_explainer:
            "Usa tu clave de rescate para encontrar intercambios pendientes que se puedan reanudar.",
        unmatched_swaps:
            "Este monedero tiene {{ count }} intercambios adicionales reclamables. Para acceder a ellos, cambia a la clave de rescate usada para iniciar esos intercambios.",
        approve: "Aprobar",
        approve_allowance_line:
            "Configura la asignación de {{ tokenStandard }} para el contrato de intercambio",
        approve_allowance_reset_line:
            "Algunos tokens {{ tokenStandard }} requieren restablecer la asignación a 0 antes de establecer una nueva cantidad. Es posible que debas aprobar dos veces.",
        upload_rescue_key: "Seleccionar clave de rescate",

        suspension_status: "Servicios de swap deshabilitados",
        suspension_p1:
            "Actualización: SATS Routing seguirá deshabilitado hasta nuevo aviso.",
        suspension_p2:
            "Nuestra API sigue disponible para procesar reembolsos de forma cooperativa. En cualquier caso, los reembolsos unilaterales funcionarán, ya que no dependen de nuestra infraestructura.",
        suspension_p3: "Nuestro equipo de soporte sigue disponible.",
        suspension_p4:
            "Para que quede claro: esto no es una respuesta a un único incidente. Durante los últimos meses hemos visto un aumento constante de sondeos automatizados y asistidos por IA contra nuestra infraestructura, y hemos lidiado con varios exploits. Cada uno fue contenido, pero el patrón es claro: los atacantes ahora iteran más rápido de lo que un equipo de nuestro tamaño puede detectar y parchear. Solo en los últimos días hemos visto una aceleración drástica, y no creemos que esta asimetría vaya a revertirse. Tras revisar los resultados de nuestros propios análisis de seguridad recientes, no podemos reactivar los swaps de SATS Routing de forma responsable, especialmente mientras somos objetivo activo de lo que parecen ser varios grupos con muchos recursos, y mientras corremos para desplegar correcciones.",
        suspension_p5:
            "Lo que estamos viendo es un cambio de paradigma importante para los servicios de Bitcoin que operan sobre un stack de código abierto, y requiere un análisis cuidadoso. No esperes que los servicios de swap se reanuden pronto.",
        suspension_p6:
            "Para ser explícitos: los fondos de los usuarios nunca estuvieron en riesgo. SATS Routing es non-custodial por diseño. Y como empresa totalmente autofinanciada, las pérdidas fueron solo nuestras.",
        suspension_p7:
            "Todavía no sabemos cómo continuará todo a partir de aquí, pero te mantendremos informado en cuanto hayamos tenido tiempo de tomar aire y decidir 🙏",
        suspension_date: "3 de agosto de 2026 · Ver en X",
    },
    pt: {
        language: "Português",
        or: "ou",
        status: "Estado",
        fast: "Rápido",
        l2: "Construído na Segunda Camada",
        l2_sub: "A SATS Routing utiliza tecnologias de segunda camada como a rede Lightning",
        assets_sub: "Camadas de Bitcoin",
        safe: "Seguro",
        non_custodial: "Não-Custodial",
        non_custodial_sub:
            "As trocas na SATS Routing são atômicas, a criptografia garante que os usuários sempre tenham controle sobre seu Bitcoin",
        node: "Nós Lightning",
        error: "Erro",
        error_subline: "Resposta inválida da API, algo deu errado.",
        error_wasm: "WebAssembly não suportado",
        history: "Histórico",
        swap: "Trocar",
        refund: "Reembolsar",
        partner: "Parceiro",
        support: "Suporte",
        docs: "Docs",
        onion: "Onion",
        terms: "Termos",
        privacy: "Privacidade",
        blockexplorer: "Abrir {{ typeLabel }}",
        blockexplorer_lockup_address: "endereço de lockup",
        blockexplorer_lockup_tx: "transação de lockup",
        blockexplorer_claim_tx: "transação de reivindicação",
        blockexplorer_refund_tx: "transação de reembolso",
        check_bridge_status: "Verificar status da ponte",
        help: "Suporte",
        network_fee: "Taxa da Rede",
        swap_fees: "Taxas da Troca",
        fee: "Taxa da SATS Routing",
        denomination: "Denominação",
        send: "Enviar",
        checking_previous_transaction: "Verificando transação anterior",
        checking_previous_transaction_line:
            "Por favor, aguarde enquanto verificamos se sua carteira enviou a transação da ponte.",
        could_not_confirm_previous_transaction:
            "Não foi possível confirmar a transação anterior",
        could_not_confirm_previous_transaction_line:
            "Não foi possível confirmar se sua carteira enviou a transação da ponte.",
        checking_previous_transaction_countdown:
            "{{ seconds }} segundos restantes.",
        check_again: "Verificar novamente",
        did_not_send_transaction: "Eu não enviei uma transação",
        did_not_send_transaction_confirm:
            "Continue apenas se tiver certeza de que sua carteira não enviou a transação. Continuar pode fazer com que você envie fundos duas vezes.",
        continue: "Continuar",
        receive: "Receber",
        max: "Máx",
        minimum_amount: "O valor mínimo é {{ amount }} {{ denomination }}",
        maximum_amount: "O valor máximo é {{ amount }} {{ denomination }}",
        assets: "Multi-Camada",
        footer: "Feito com 🧡 pela SATS Routing",
        create_swap: "Criar troca",
        get_gas_token_for_gas: "Obtenha {{ gasToken }} para gas",
        new_swap: "Nova troca",
        feecheck:
            "A taxa da rede foi atualizada conforme a situação atual, por favor confirme os novos valores e continue a troca.",
        amount_limits_changed:
            "Os limites da troca mudaram. Por favor confirme os novos valores e continue a troca.",
        commitment_invoice_heading:
            "Insira um invoice Lightning de {{ amount }} {{ denomination }}",
        commitment_invoice_deferred:
            "Insira o destino Lightning após o pagamento",
        clear_amount: "Limpar",
        create_and_paste:
            "Cole um invoice Lightning, um endereço BOLT12 ou um LNURL para receber os fundos",
        invoice_cleared_amount_changed:
            "O invoice foi removido porque o valor mudou.",
        congrats: "Parabéns!",
        successfully_swapped:
            "{{ amount }} {{ denomination }} recebidos com sucesso!",
        bridge_transfer_pending:
            "Troca concluída! Seus {{ amount }} {{ denomination }} foram enviados pela ponte {{ network }}. Transferências por pontes podem levar alguns minutos para finalizar.",
        timeout_eta: "Estimativa de Expiração",
        pay_invoice: "Troca: {{ id }}",
        pay_swap_404: "Troca não encontrada!",
        pay_timeout_blockheight: "Altura do Bloco de Expiração ({{ network }})",
        send_to: "Envie {{ amount }} {{ denomination }} para",
        send_between:
            "Envie entre {{ min }} e {{ max }} {{ denomination }} para",
        pay_invoice_to: "Pague este invoice de {{ amount }} {{ denomination }}",
        no_wallet: "Nenhuma carteira instalada",
        connect_wallet: "Conectar carteira",
        please_connect_wallet: "Por favor, conecte a carteira",
        connect_to_address: "Conectar ao endereço da troca",
        disconnect_address: "Desconectar carteira",
        lockup_failed: "Falha no lockup!",
        failure_reason: "Motivo da falha",
        invoice_payment_failure: "Não foi possível pagar seu invoice Lightning",
        onchain_address:
            "Digite um endereço {{ asset }} para receber os fundos",
        onchain_address_no_asset: "Digite o endereço",
        invalid_refund_file: "Chave de resgate inválida",
        invalid_invoice:
            "Por favor, forneça um invoice Lightning, BOLT12 ou LNURL válido",
        invalid_0_amount: "Invoices sem valor não são suportadas",
        copy_invoice: "Invoice Lightning",
        copy_address: "Endereço",
        copy_amount: "Quantia",
        copy_bip21: "BIP21",
        rescue_a_swap_subline:
            "Se enviou BTC ou LBTC para uma troca SATS Routing, faça upload ou insira sua chave de resgate para resgatar uma troca que não está no histórico deste navegador.",
        rescue_a_swap_mnemonic:
            "Insira sua chave de resgate para resgatar uma troca que não está no histórico deste navegador.",
        refund_past_swaps: "Trocas passadas",
        refund_past_swaps_subline:
            "Trocas que foram salvas no armazenamento do seu navegador",
        no_rescuable_swaps:
            "Nenhuma troca resgatável encontrada no histórico do navegador",
        refund_external_scanning_evm:
            "Procurando trocas resgatáveis em redes EVM...",
        connected_wallet_no_swaps:
            "A carteira Rootstock conectada não contém nenhuma troca resgatável.",
        history_no_swaps: "Parece que ainda não foram feitas trocas.",
        refund_address_header:
            "Informe um endereço {{ asset }} para receber seu reembolso:",
        refund_address_header_no_asset:
            "Informe um endereço para receber seu reembolso:",
        history_export: "Exportar",
        refund_clear: "Apagar armazenamento",
        delete_storage:
            "Tem certeza de que deseja limpar seu armazenamento?\nAs informações das suas trocas e as chaves privadas de reembolso/recebimento serão perdidas.",
        delete_storage_single_swap:
            "Tem certeza de que deseja remover a troca {{ id }} do armazenamento?\nAs informações da troca e as chaves privadas de reembolso/recebimento serão perdidas.",
        delete_logs: "Tem certeza que deseja limpar seus logs?",
        tx_in_mempool: "Transação na mempool",
        tx_in_mempool_subline: "Aguardando confirmação para concluir a troca.",
        tx_in_mempool_warning:
            "Mantenha esta página aberta, senão a troca não termina!",
        invoice_pending: "Transação recebida, a pagar o invoice.",
        invoice_pending_pro:
            "Transação recebida, invoice em fila. Em algumas ocasiões, a troca pode ser cancelada.",
        invoice_expired: "Invoice expirado, tente novamente!",
        create_invoice_webln: "Criar invoice via WebLN",
        pay_invoice_webln: "Pagar invoice via WebLN",
        select_asset_send: "Selecionar ativo a enviar",
        select_asset_receive: "Selecionar ativo a receber",
        select_network: "Selecionar rede",
        search: "Pesquisar",
        tx_confirmed: "Transação confirmada",
        tx_ready_to_claim: "Reivindicando transação agora...",
        refunded: "Troca reembolsada com sucesso!",
        refunded_bridge_pending:
            "Troca reembolsada. Seu {{ denomination }} está sendo enviado de volta pela ponte para {{ network }} e pode levar algum tempo para chegar.",
        locktime_not_satisfied: "O prazo de lockup não foi cumprido",
        already_refunded: "A troca já foi reembolsada",
        api_offline: "A API está offline",
        api_offline_msg:
            "Não foi possível conectar à API da SATS Routing, por favor tente novamente mais tarde",
        refund_explainer:
            "Será possível reembolsar a troca após o prazo de expiração!",
        wasm_not_supported: "Ative o WebAssembly no seu navegador",
        created: "Criado",
        view: "Ver",
        id: "ID",
        headline: "Bitcoin Bridge Não-Custodial",
        headline_pro: "Acumule Sats Com Autocustódia",
        subline:
            "Troque entre as diferentes camadas do Bitcoin, mantendo controle total.",
        subline_pro:
            "Ganhe sats por trocar Bitcoin em direções que ajudam a balancear nossa liquidez.",
        start_swapping: "Começar a trocar",
        partners: "Parceiros",
        integrations: "Integrações",
        oldest_channel_years: "{{ years }} anos",
        oldest_channel: "Canal mais antigo",
        capacity: "Capacidade ({{ denomination }})",
        peers: "Número de pares",
        num_channels: "Número de canais",
        beta_caution: "BETA - USE COM CUIDADO!",
        pro: "pro",
        pro_banner: "Quer usar a SATS Routing Pro via API?",
        warning_return:
            "Volte a esta página após pagar o invoice! O pagamento pode aparecer como pendente até que volte a esta página.",
        warning_expiry:
            "Certifique-se de que sua transação seja confirmada em até 24h após a criação da troca!",
        not_found: "404 - Not Found",
        not_found_subline: "Esta página parece ter desaparecido.",
        back_to_home: "Voltar à página inicial",
        transaction_prompt:
            'Pressione "{{ button }}" para abrir sua carteira conectada e confirmar a transação exibida.',
        transaction_prompt_receive:
            'Pressione "{{ button }}" para começar a reivindicar {{ asset }}.',
        transaction_failed: "Falha na transação: {{ error }}",
        wallet_request_rejected: "A solicitação foi rejeitada na sua carteira.",
        invalid_address: "Endereço {{ asset }} inválido",
        scan_qr_code: "Ler QR Code",
        version: "Versão",
        commithash: "Hash do Commit",
        open_in_wallet: "Abrir na carteira",
        branding: "Identidade Visual",
        regtest: "Regtest",
        broadcasting_claim: "Transmitindo transação de reivindicação...",
        paste_invalid:
            "Conteúdo da área de transferência inválido ou valor excedido",
        email: "Email",
        switch_paste:
            "Direção/ativo da troca alterado com base no conteúdo colado",
        settings: "Configurações",
        decimal_separator: "Separador decimal",
        denomination_tooltip: "Escolha a denominação preferida: BTC ou sats",
        decimal_tooltip: "Escolha o separador decimal: ponto ou vírgula",
        fiat_rate_not_available: "Valor fiat indisponível",
        fiat_currency: "Moeda fiat",
        fiat_currency_tooltip: "Moeda usada para o equivalente fiat",
        swap_completed: "Troca {{ id }} concluída com sucesso!",
        claim_fail: "Falha ao reivindicar troca: {{ id }}",
        logs: "Logs",
        logs_tooltip: "Logs do app, útil para debugging",
        share_with_support: "Compartilhar com o suporte",
        chatwoot_not_ready:
            "O chat de suporte está abrindo — por favor, tente compartilhar seus logs novamente assim que ele carregar.",
        hide_wallet_address: "Modo de Privacidade",
        hide_wallet_address_tooltip:
            "Oculta o endereço da carteira EVM e o ID do Swap para privacidade em demos e gravações",
        bitcoin_only: "Modo Bitcoin-Only",
        bitcoin_only_tooltip:
            "Mostrar apenas Bitcoin e Lightning, ocultando todos os outros pares",
        bitcoin_only_warning:
            "Modo Bitcoin-Only está ativado. Desative-o nas configurações para trocar outros ativos.",
        slippage: "Slippage",
        slippage_tooltip: "Tolerância máxima de slippage para trocas em DEX",
        gas_topup: "Recarga automática de gas",
        gas_topup_tooltip:
            "Converte automaticamente uma pequena parte da sua troca em gas nativo se a sua carteira conectada não tiver gas.",
        gas_topup_label: "Gas de destino ({{ gasToken }}) incluido",
        bridge_messaging_fee: "Taxa de Mensagem da Ponte",
        bridge_transfer_fee: "Taxa de Transferência da Ponte",
        retry: "Tentar novamente",
        error_bridge_capacity: "O valor excede a capacidade da ponte",
        error_no_quote:
            "Não foi possível obter uma cotação. Por favor, verifique sua conexão e tente novamente.",
        error_zero_quote: "Aumente o valor a enviar",
        oft_eta: "Chegada estimada em cerca de {{ time }}",
        oft_eta_day_unit: "{{ value }}d",
        oft_eta_hour_unit: "{{ value }}h",
        oft_eta_minute_unit: "{{ value }}min",
        oft_eta_second_unit: "{{ value }}s",
        oft_arriving_soon: "Chegando em breve...",
        oft_transfer_in_progress: "Transferência em andamento",
        waiting_for_bridge: "Aguardando a ponte {{ symbol }}",
        dex_quote_changed: "A cotação da DEX mudou",
        commitment_rejected_line:
            "O valor enviado ficou insuficiente, portanto esta troca não pode ser concluída. Você pode reembolsar seus fundos para o seu endereço original.",
        pre_bridge_dex_quote_blocked: "A cotação mudou",
        pre_bridge_dex_quote_blocked_line:
            "Os preços mudaram enquanto seus fundos eram transferidos pela ponte, então a cotação não é mais suficiente para completar o swap. Tente novamente ou reembolse seus fundos.",
        recovering_bridged_funds: "Reembolsando...",
        pre_bridge_refund_initiated:
            "Os seus fundos estão a ser enviados de volta para o seu endereço original através da ponte e chegarão em breve.",
        retry_quote: "Tentar novamente",
        retrying_quote: "Verificando cotação...",
        zero_conf: "Zero-Conf",
        zero_conf_tooltip:
            "Aceitar transações que ainda não foram confirmadas num bloco",
        on: "on",
        off: "off",
        invalid_pair: "Par inválido",
        invalid_send_asset: "Ativo de envio inválido",
        error_starting_qr_scanner:
            "Não foi possível acessar a câmera, verifique as permissões!",
        insufficient_balance: "Saldo insuficiente",
        insufficient_balance_line:
            "Não há saldo suficiente na sua carteira para essa troca.",
        insufficient_gas_balance_line:
            "Você não tem {{ gasToken }} suficiente para financiar a troca.",
        select_wallet: "Selecionar carteira",
        select_derivation_path: "Selecionar caminho de derivação",
        submit_derivation_path: "Enviar",
        not_supported_in_browser: "Não suportado neste navegador",
        switch_network: "Trocar rede",
        block: "bloco",
        logs_scan_progress: "Progresso da varredura {{ value }}%",
        logs_deriving_keys: "Derivando chaves... ({{ count }} até agora)",
        accept: "Aceitar",
        wallet_connect_failed: "Falha ao conectar carteira: {{ error }}",
        ledger_open_app_prompt: "Abra o app Ethereum ou RSK",
        validate_payment: "Mostrar Prova de Pagamento",
        no_browser_wallet: "Nenhuma carteira de navegador detectada",
        sent: "Enviado",
        will_receive: "Você receberá",
        refund_available_in:
            "Reembolso estará disponível em {{ blocks }} blocos",
        no_wallet_connected: "Nenhuma carteira conectada",
        no_lockup_transaction: "Nenhuma transação de lockup encontrada",
        routing_fee_limit: "Limite da Taxa de Roteamento",
        download_boltz_rescue_key: "Chave de resgate da SATS Routing",
        download_boltz_rescue_key_subline:
            "Faça backup de todas as suas trocas com uma única chave de resgate 🙌",
        download_boltz_rescue_key_subline_second:
            "Esta chave funciona em qualquer dispositivo e para todas as trocas criadas com ela.",
        download_boltz_rescue_key_subline_backup:
            "Para continuar, faça backup dela.",
        download_boltz_rescue_key_subline_privacy:
            "**Cuidado:** Navegadores focados em privacidade podem excluir arquivos baixados ao serem fechados.",
        download_boltz_rescue_key_subline_save:
            "Guarde a chave de resgate em um local **SEGURO** e **PERMANENTE**!",
        download_boltz_rescue_key_subline_warning:
            "Não fazer isso pode levar à **PERDA DE FUNDOS**.",
        download_new_key: "Baixar chave de resgate",
        verify_boltz_rescue_key: "Verificar chave de resgate",
        verify_boltz_rescue_key_subline:
            "Selecione sua chave de resgate previamente baixada para verificá-la.",
        verify_key: "Verificar chave",
        verify_key_failed:
            "Falha ao verificar a chave de resgate. Recomendamos baixar uma nova chave.",
        rescue_key: "Chave de resgate",
        reset_rescue_key_tooltip:
            "Gerar uma nova chave de resgate e limpar todos os dados de trocas",
        reset_rescue_key_prompt:
            "⚠️ AVISO: Isso excluirá TODOS os seus dados de trocas e gerará uma nova chave de resgate.\n\nNão prossiga a não ser que você tenha um backup para a chave de resgate existente ou tenha certeza absoluta de que não precisará mais dela.\n\nDigite 'confirm' para continuar:",
        reset_rescue_key_invalid_confirmation:
            "Confirmação inválida. Por favor, digite 'confirm' para continuar.",
        reset_rescue_key_error:
            "Ocorreu um erro ao redefinir a chave de resgate. Por favor, tente novamente.\n\nErro: {{ error }}",
        reset_rescue_key_success: "Nova chave de resgate gerada com sucesso!",
        encrypt_rescue_key: "Criptografar",
        decrypt_rescue_key: "Remover criptografia",
        encrypt_rescue_key_tooltip:
            "Criptografe a chave de resgate em repouso com uma senha. Você precisará da senha para desbloqueá-la neste navegador.",
        set_rescue_passphrase_prompt:
            "Digite uma senha para criptografar sua chave de resgate em repouso.\n\nAVISO: se você esquecer esta senha e não tiver um backup da chave de resgate, seus fundos serão irrecuperáveis.",
        confirm_rescue_passphrase_prompt:
            "Digite a senha novamente para confirmar:",
        rescue_passphrase_empty: "A senha não pode estar vazia.",
        rescue_passphrase_mismatch:
            "As senhas não coincidem. Tente novamente.",
        encrypt_rescue_key_success:
            "Chave de resgate criptografada com sucesso!",
        encrypt_rescue_key_error:
            "Ocorreu um erro ao criptografar a chave de resgate.\n\nErro: {{ error }}",
        disable_rescue_encryption_prompt:
            "Remover a criptografia por senha e armazenar a chave de resgate em texto puro novamente?\n\nDigite 'confirm' para continuar:",
        disable_rescue_encryption_success: "Criptografia removida.",
        unlock_rescue_key_title: "Desbloqueie sua chave de resgate",
        unlock_rescue_key_description:
            "Sua chave de resgate está criptografada. Digite sua senha para desbloqueá-la e continuar.",
        unlock_rescue_key_placeholder: "Senha",
        unlock_rescue_key_button: "Desbloquear",
        unlock_rescue_key_invalid: "Senha inválida. Tente novamente.",
        no_swaps_found: "Nenhuma troca encontrada",
        rif_extra_fee:
            "A carteira não tem RBTC suficiente, taxa ajustada para incluir taxa do RIF Relay!",
        back: "Voltar",
        next: "Próximo",
        pagination_info: "Página {{ start }} de {{ end }}",
        generate_key: "Gerar nova chave",
        show_rescue_key_instead:
            "Mostrar a chave de resgate de 12 palavras em vez disso",
        backup_boltz_rescue_key: "Backup chave de resgate da SATS Routing",
        backup_boltz_rescue_key_subline_second:
            "Esta nova chave funciona em qualquer dispositivo e funciona para todas as trocas criadas com ela.",
        backup_boltz_rescue_key_subline_third:
            "Por favor, escreva ou copie esta chave e armazene-a em um local seguro e permanente.",
        backup_boltz_rescue_key_reminder: "Guarde com segurança. Não partilhe.",
        copy_rescue_key: "Copiar chave de resgate",
        user_saved_key: "Eu guardei a chave de resgate",
        verify_mnemonic_word: {
            start: "Qual é a palavra na ",
            strong: "posição {{ number }}",
            end: " da sua chave de resgate?",
        },
        incorrect_word:
            "Palavra incorreta. Por favor, verifique sua chave de resgate.",
        enter_mnemonic: "Digitar chave de resgate",
        verify_boltz_rescue_key_mnemonic:
            "Por favor, digite sua chave de resgate abaixo para importá-la.",
        hint_paste_mnemonic: "Dica: você pode colar as 12 palavras de uma vez.",
        swap_opportunities: "Oportunidades Pro Disponíveis",
        swap_opportunities_subline:
            "Ganhe sats ou obtenha descontos trocando estes pares",
        pro_fee: "Taxa Pro",
        regular_fee: "Taxa Regular",
        swap_opportunities_accordion: "Oportunidades Pro",
        no_opportunities_found: {
            text: "Nenhuma oportunidade Pro encontrada. Verifique novamente mais tarde.",
            telegram_bot_text_prefix:
                "Para alertas de taxas, acesse nosso bot no ",
            telegram_bot_text_middle: " ou ",
            telegram_bot_text_suffix: ".",
            telegram_bot: "Telegram",
            simplex: "SimpleX",
        },
        refresh_for_refund:
            "Se enviou Bitcoin para esta troca, atualize a página para verificar se existe um reembolso.",
        applied_routing_hint:
            "O seu destinatário suporta o recebimento direto de {{ asset }}. Assim, você poupa em taxas e ele continua a receber o valor total.",
        optimized_route_amount:
            "Rota de troca otimizada, poupando-te ~{{ amount }} {{ denomination }}",
        claim: "Reivindicar",
        claimed: "Troca reivindicada com sucesso!",
        rescue: "Resgatar",
        rescue_swaps: "Resgatar trocas",
        rescue_swap: "Resgatar Troca",
        failed_get_swap: "Não foi possível obter a troca {{ id }}",
        failed_get_swap_subline:
            "Por favor, re-insira a chave de resgate e tente novamente.",
        in_progress: "Em curso",
        completed: "Finalizada",
        get_refundable_error:
            "Não foi possível carregar os dados de UTXO. Atualize a página para voltar a tentar ou verifique sua conexão com a Internet se o problema persistir.",
        min_amount_destination:
            "O valor mínimo para o endereço de destino é {{ amount }} {{ denomination }}",
        max_amount_destination:
            "O valor máximo para o endereço de destino é {{ amount }} {{ denomination }}",
        exact_amount_destination:
            "O valor do invoice deve ser exatamente {{ amount }} {{ denomination }}",
        destination: "Destino",
        destination_address: "{{ address }}",

        // Products page
        products: "Produtos",
        products_description:
            "Um conjunto de produtos para integração perfeita entre as camadas do Bitcoin",
        products_plugin_title: "SATS Routing BTCPay Plugin",
        products_plugin_description:
            "Uma solução não-custodial para aceitar pagamentos Lightning facilmente, sem ter um nó Lightning",
        products_client_title: "SATS Routing Client",
        products_client_description:
            "Nosso daemon empresarial de trocas, para integrações em servidores e gestão de liquidez",
        products_pro_title: "SATS Routing Pro",
        products_pro_description:
            "Uma plataforma que permite ganhar sats através de trocas",
        learn_more: "Saiba mais",
        get_started: "Abrir SATS Routing Pro",
        documentation: "Documentação",
        view_on_github: "Ver no Github",
        chat_with_us: "Converse conosco",

        // Plugin
        boltz_plugin_name: "Plugin SATS Routing BTCPay",
        boltz_plugin_description:
            "Solução não-custodial para aceitar pagamentos Lightning facilmente",
        boltz_plugin_step_install_title: "Instale o plugin",
        boltz_plugin_step_install_description:
            "Instale o plugin SATS Routing no seu servidor BTCPay",
        boltz_plugin_step_setup_title: "Configure sua carteira",
        boltz_plugin_step_setup_description:
            "Conecte sua carteira externa ou crie uma nova",
        boltz_plugin_step_paid_title: "Receba Lightning",
        boltz_plugin_step_paid_description:
            "Receba pagamentos Lightning com liquidação automática em Bitcoin mainchain",
        boltz_plugin_features_title: "Por que usar?",
        boltz_plugin_features_description:
            "Feito para comerciantes que querem controle total, sem complexidades",
        boltz_plugin_feature_flexible_title: "Flexível",
        boltz_plugin_feature_flexible_description:
            "Aceite pagamentos Lightning sem ter um nó ou gerencie 100% da liquidez de um nó Lightning existente",
        boltz_plugin_feature_liquid_title: "Impulsionado pela Liquid",
        boltz_plugin_feature_liquid_description:
            "Aproveite o poder de trocas Taproot via Liquid para taxas menores e maior privacidade",
        boltz_plugin_feature_autoswap_title: "Liquidação em Bitcoin",
        boltz_plugin_feature_autoswap_description:
            "Troca automática para Bitcoin mainchain com base nas suas preferências",
        boltz_plugin_feature_self_custodial_title: "Não-custodial",
        boltz_plugin_feature_self_custodial_description:
            "Mantenha o controle total dos seus Bitcoin com o poder das trocas atômicas da SATS Routing",

        boltz_plugin_questions_title: "Dúvidas?",
        boltz_plugin_questions_subtitle: "Adoraríamos ouvir você!",
        // Client
        boltz_client_name: "SATS Routing Client",
        boltz_client_description:
            "Daemon empresarial de trocas para integrações em servidores e gestão de liquidez",
        boltz_client_features_title: "Feito para empresas e profissionais",
        boltz_client_features_description:
            "Recursos avançados, projetados para operadores profissionais de nós Lightning",
        boltz_client_feature_taproot_title: "Taproot-First",
        boltz_client_feature_taproot_description:
            "Utiliza trocas Taproot para maior eficiência e privacidade",
        boltz_client_node_agnostic_title: "Agnóstico de Nó",
        boltz_client_node_agnostic_description:
            "Suporte de primeira classe para CLN, além de LND, dando flexibilidade à sua infraestrutura",
        boltz_client_autoswap_title: "Auto-Troca Inteligente",
        boltz_client_autoswap_description:
            "Controle granular para rebalanceamento automático de canais, com configurações ajustáveis e liquidação inteligente em Bitcoin",
        boltz_client_liquid_title: "Liquid-First",
        boltz_client_liquid_description:
            "Otimizado para rebalanceamento de canais usando trocas Liquid para taxas baixas, execução rápida e maior privacidade",
        boltz_client_cli_title: "API e CLI robustas",
        boltz_client_cli_first_paragraph:
            "Carteira integrada e API abrangente para integração perfeita na sua infraestrutura.",
        boltz_client_cli_second_paragraph:
            "Monitore, controle e automatize tudo via linha de comando ou com seus próprios apps.",
        boltz_client_cta_title: "Adicione a SATS Routing à sua infraestrutura!",
        boltz_client_cta_subtitle:
            "Junte-se à comunidade de empresas e operadores de nós que usam o SATS Routing Client",

        // Pro
        boltz_pro_name: "SATS Routing Pro",
        boltz_pro_description:
            "Uma plataforma que permite ganhar sats através de trocas",
        boltz_pro_how_it_works_title: "Como funciona",
        boltz_pro_how_it_works_description:
            "Você é pago por fazer trocas em direções que nos ajudam a reequilibrar nossa liquidez",
        boltz_pro_chart_title: "Amostra de Histórico de Taxas SATS Routing Pro",
        boltz_pro_chart_y_axis: "Taxa SATS Routing Pro",
        boltz_pro_chart_x_axis: "Data",
        boltz_pro_negative_fee: "Você ganha sats",
        boltz_pro_lower_fee: "Você economiza sats",
        boltz_pro_regular_fee: "Taxa Regular SATS Routing",
        boltz_pro_target_audience_title: "Para quem é a SATS Routing Pro?",
        boltz_pro_target_audience_subtitle:
            "Feita para profissionais que querem ganhar sats, não para pagamentos do dia a dia",
        boltz_pro_perfect_for_title: "Feita para",
        boltz_pro_perfect_for_1:
            "Operadores de nós Lightning que buscam reduzir o excesso de liquidez inbound para ganhar sats",
        boltz_pro_perfect_for_2:
            "Profissionais colaborando com operadores de nós externos para gerenciar liquidez",
        boltz_pro_perfect_for_3:
            "Usuários recarregando carteiras Lightning dentro dos limites de roteamento da SATS Routing Pro",
        boltz_pro_not_designed_for_title: "Não adequada para",
        boltz_pro_not_designed_for_1:
            "Pagamentos Lightning do dia a dia, como comprar um café",
        boltz_pro_not_designed_for_2:
            "Confiabilidade no pagamento a destinos com altas taxas de roteamento",
        boltz_pro_not_designed_for_3:
            "Cenários que exigem garantia de execução de pagamento instantâneo",
        boltz_pro_cta_title: "Comece a ganhar sats agora!",
        boltz_pro_cta_subtitle:
            "Descubra as oportunidades atuais para ganhar sats",
        boltz_pro_options_title: "3 maneiras de usar a SATS Routing Pro",
        boltz_pro_options_subtitle: "Escolha a que melhor se adapta a você",
        boltz_pro_option_client_title: "SATS Routing Client",
        boltz_pro_option_client_description:
            "Automatize completamente a SATS Routing Pro com API e CLI",
        boltz_pro_option_web_title: "App Web",
        boltz_pro_option_web_description:
            "Observe e execute trocas com nosso app web SATS Routing Pro",
        boltz_pro_option_chat_title: "Bots de chat",
        boltz_pro_option_chat_description_prefix:
            "Receba alertas instantâneos no",
        boltz_pro_option_chat_description_middle: "ou",
        boltz_pro_option_chat_description_suffix: ".",

        balance: "Saldo",
        display: "Exibição",
        security: "Segurança",
        failed: "Falhou",
        swaps_found: "Buscando trocas ({{ count }} encontradas)",
        claim_scan_required:
            "Para reivindicar esta troca, volte e escaneie com o arquivo de resgate carregado.",
        refund_scan_required:
            "Para reembolsar este saldo, volte e escaneie com o arquivo de resgate carregado.",
        refund_destination_hint:
            "Os fundos serão reembolsados como {{ symbol }} via {{ network }} para sua carteira EVM conectada.",
        invalid_rescue_key_evm:
            "Esta chave de resgate não está associada a esta troca. Por favor, tente novamente usando uma chave de resgate diferente.",
        error_occurred: "Ocorreu um erro: {{ error }}",
        rescue_external_select_method:
            "Selecione pelo menos um método de resgate",
        rescue_external_subtitle:
            "Use esta página para resgatar trocas que não estão disponíveis na aba de histórico.",
        rescue_external_report_issue_start:
            "Se você acha que sua troca falhou devido a um problema do nosso lado, por favor ",
        rescue_external_report_issue_link: "clique aqui",
        rescue_external_report_issue_end:
            " para compartilhar os logs e nos dar alguns detalhes sobre sua troca.",
        rescue_external_coverage:
            "Resgatável com os métodos de resgate fornecidos",
        rescue_external_requires_rescue_key: "Requer chave de resgate",
        rescue_external_requires_wallet: "Requer carteira",
        rescue_external_requires_rescue_key_wallet:
            "Requer chave de resgate e carteira",
        rescue_external_resume: "Continuar",
        evm_rescue_prompt:
            'Se você enviou fundos para uma troca da SATS Routing em uma rede EVM, use "Reembolsar troca"; se estava recebendo fundos de uma rede EVM, use "Continuar troca" para resgatar uma troca que não está disponível no histórico deste navegador.',
        evm_rescue_refund_title: "Reembolsar troca",
        start_scanning: "Iniciar varredura",
        stop_scanning: "Parar varredura",
        evm_rescue_resume_title: "Continuar troca",
        evm_rescue_resume_explainer:
            "Use sua chave de resgate para encontrar trocas pendentes que podem ser continuadas.",
        unmatched_swaps:
            "Esta carteira tem {{ count }} trocas adicionais reivindicáveis. Para acessá-las, mude para a chave de resgate usada para iniciar essas trocas.",
        approve: "Aprovar",
        approve_allowance_line:
            "Definir a permissão de {{ tokenStandard }} para o contrato de troca",
        approve_allowance_reset_line:
            "Alguns tokens {{ tokenStandard }} exigem redefinir a permissão para 0 antes de definir um novo valor. Talvez você precise aprovar duas vezes.",
        upload_rescue_key: "Selecionar chave de resgate",

        suspension_status: "Serviços de swap desativados",
        suspension_p1:
            "Atualização: a SATS Routing permanecerá desativada até novo aviso.",
        suspension_p2:
            "Nossa API continua disponível para processar reembolsos de forma cooperativa. De qualquer forma, os reembolsos unilaterais funcionarão, pois não dependem da nossa infraestrutura.",
        suspension_p3: "Nossa equipe de suporte continua acessível.",
        suspension_p4:
            "Para deixar claro: esta não é uma resposta a um único incidente. Nos últimos meses vimos um aumento constante de sondagens automatizadas e assistidas por IA na nossa infraestrutura, e lidamos com vários exploits. Cada um foi contido, mas o padrão é claro: os atacantes agora iteram mais rápido do que uma equipe do nosso tamanho consegue encontrar e corrigir. Só nos últimos dias vimos uma aceleração drástica, e não acreditamos que essa assimetria vá se reverter. Depois de revisar os resultados das nossas próprias verificações de segurança recentes, não podemos reativar os swaps da SATS Routing de forma responsável, especialmente enquanto somos alvo ativo do que parecem ser vários grupos com muitos recursos, e enquanto corremos para implantar correções.",
        suspension_p5:
            "O que estamos vendo é uma grande mudança de paradigma para serviços de Bitcoin que operam sobre uma stack de código aberto, e isso exige uma análise cuidadosa. Não espere que os serviços de swap voltem em breve.",
        suspension_p6:
            "Para ser explícito: os fundos dos usuários nunca estiveram em risco. A SATS Routing é non-custodial por design. E, como empresa totalmente autofinanciada, os prejuízos foram só nossos.",
        suspension_p7:
            "Ainda não sabemos como as coisas seguirão a partir daqui, mas manteremos você informado assim que tivermos tido tempo de respirar e tomar uma decisão 🙏",
        suspension_date: "3 de agosto de 2026 · Ver no X",
    },
    zh: {
        language: "中文",
        or: "或",
        status: "状态",
        fast: "快速",
        l2: "建立在二层网络之上",
        l2_sub: "SATS Routing利用像闪电网络这样的二层网络扩展技术",
        assets_sub: "比特币层",
        safe: "安全",
        non_custodial: "非托管",
        non_custodial_sub:
            "SATS Routing上的交换是原子式,密码学确保用户始终掌握自己的资金",
        node: "闪电网络节点",
        error: "错误",
        error_subline: "API的响应无效，出现异常。",
        error_wasm: "不支持WebAssembly",
        history: "历史",
        swap: "交换",
        refund: "退款",
        partner: "合作伙伴",
        support: "支持",
        docs: "文档",
        onion: "洋葱",
        terms: "条款",
        privacy: "隐私",
        blockexplorer: "打开{{ typeLabel }}",
        blockexplorer_lockup_address: "锁仓地址",
        blockexplorer_lockup_tx: "锁仓交易",
        blockexplorer_claim_tx: "索赔交易",
        blockexplorer_refund_tx: "退款交易",
        check_bridge_status: "查看桥接状态",
        help: "支持",
        network_fee: "网络费",
        swap_fees: "交换费用",
        fee: "SATS Routing费",
        denomination: "面额",
        send: "发送",
        checking_previous_transaction: "正在检查上一笔交易",
        checking_previous_transaction_line:
            "请稍候，我们正在检查您的钱包是否已提交桥接交易。",
        could_not_confirm_previous_transaction: "无法确认上一笔交易",
        could_not_confirm_previous_transaction_line:
            "我们无法确认您的钱包是否已提交桥接交易。",
        checking_previous_transaction_countdown: "剩余 {{ seconds }} 秒。",
        check_again: "再次检查",
        did_not_send_transaction: "我没有发送交易",
        did_not_send_transaction_confirm:
            "仅当您确定钱包没有提交该交易时才继续。继续可能会导致您重复发送资金。",
        continue: "继续",
        receive: "接收",
        max: "最大",
        minimum_amount: "最小金额为{{ amount }}{{ denomination }}",
        maximum_amount: "最大金额为{{ amount }}{{ denomination }}",
        assets: "多层",
        footer: "SATS Routing 倾情🧡制作",
        create_swap: "创建交换",
        get_gas_token_for_gas: "获取{{ gasToken }}作为 Gas 费",
        new_swap: "新的交换",
        feecheck: "根据网络情况更新了网络费用，请确认新的金额并继续进行交换。",
        amount_limits_changed: "兑换限额已变更，请确认新的金额并继续进行兑换。",
        commitment_invoice_heading:
            "输入 {{ amount }} {{ denomination }} 的闪电发票",
        commitment_invoice_deferred: "支付后输入闪电网络目标",
        clear_amount: "清除",
        create_and_paste: "粘贴闪电发票、BOLT12 地址或 LNURL 以接收资金",
        invoice_cleared_amount_changed: "金额已更改，发票已清除。",
        congrats: "恭喜！",
        successfully_swapped: "您成功收到{{ amount }}{{ denomination }}！",
        bridge_transfer_pending:
            "交换已完成！您的 {{ amount }} {{ denomination }} 已通过 {{ network }} 桥发送。桥接转账可能需要几分钟才能完成。",
        timeout_eta: "超过预期时间",
        pay_invoice: "交换：{{ id }}",
        pay_swap_404: "找不到交换！",
        pay_timeout_blockheight: "超时区块高度 ({{ network }})",
        send_to:
            "请将准确的{{ amount }}{{ denomination }}发送到以下地址。您可以使用“BIP21”按钮，并将其粘贴到钱包。",
        send_between: "在 {{ min }} 和 {{ max }} {{ denomination }} 之间发送至",
        pay_invoice_to: "支付金额为{{ amount }}{{ denomination }}的发票",
        no_wallet: "未安装钱包",
        connect_wallet: "连接钱包",
        please_connect_wallet: "请连接钱包",
        connect_to_address: "连接交换地址",
        disconnect_address: "断开钱包",
        lockup_failed: "锁仓失败！",
        failure_reason: "失败原因",
        invoice_payment_failure: "无法支付您的闪电发票",
        onchain_address: "输入{{ asset }}地址以接收资金",
        onchain_address_no_asset: "地址",
        invalid_refund_file: "无效的救援钥匙",
        invalid_invoice: "请提供有效的发票,BOLT12或LNURL",
        invalid_0_amount: "不支持没有金额的发票",
        copy_invoice: "闪电网络发票",
        copy_address: "地址",
        copy_amount: "金额",
        copy_bip21: "BIP21",
        rescue_a_swap_subline:
            "如果您向 SATS Routing 交换发送了 BTC 或 LBTC，请上传或输入您的救援密钥，以恢复在该浏览器的交换历史记录中不可用的交换。",
        rescue_a_swap_mnemonic:
            "输入您的救援密钥以恢复此浏览器交换历史记录中不存在的交换。",
        refund_past_swaps: "过去的交换",
        refund_past_swaps_subline: "保存在浏览器存储中的交换",
        no_rescuable_swaps: "在您的浏览器历史记录中未找到可恢复的交换记录。",
        refund_external_scanning_evm: "正在扫描 EVM 链上的可恢复交换...",
        connected_wallet_no_swaps:
            "已连接的Rootstock钱包中不包含任何可恢复的交换。",
        history_no_swaps: "看起来您还没有进行任何交换。",
        refund_address_header: "输入要退款的 {{ asset }} 钱包地址",
        refund_address_header_no_asset: "输入要退款的钱包地址",
        history_export: "导出",
        refund_clear: "删除本地存储",
        delete_storage:
            "您确定要清除本地存储吗？\n您的交换信息和您的退款/索赔私钥将丢失。",
        delete_storage_single_swap: "您确定要从本地存储中清除交换{{ id }}吗",
        delete_logs: "您确定要删除日志吗？",
        tx_in_mempool: "事务在内存池中",
        tx_in_mempool_subline: "等待确认以完成交换",
        tx_in_mempool_warning: "请保持此页打开，否则兑换无法完成！",
        invoice_pending: "收到交易，正在支付发票。",
        invoice_pending_pro:
            "收到交易，发票已排队。在某些情况下，兑换可能会被取消。",
        invoice_expired: "发票已过期，请重试！",
        create_invoice_webln: "通过WebLN创建发票",
        pay_invoice_webln: "通过WebLN支付发票",
        select_asset_send: "选择发送资产",
        select_asset_receive: "选择接收资产",
        select_network: "选择网络",
        search: "搜索",
        tx_confirmed: "交易已确认",
        tx_ready_to_claim: "现在要求交换……",
        refunded: "交换已退还",
        refunded_bridge_pending:
            "交换已退还。您的 {{ denomination }} 正在桥接回 {{ network }}，可能还需一些时间到账。",
        locktime_not_satisfied: "未满足锁定时间要求",
        already_refunded: "交换已经退还",
        api_offline: "API离线",
        api_offline_msg: "无法连接到SATS Routing API,请稍后重试",
        refund_explainer: "您将能够在超时后退款!",
        wasm_not_supported: "请在您的浏览器中激活WebAssembly",
        created: "已创建",
        view: "查看",
        id: "ID",
        headline: "非托管比特币跨链桥",
        headline_pro: "积累聪，非托管！",
        subline: "在不同比特币层之间交换，同时保持完全控制。",
        subline_pro: "通过交换比特币赚取聪，在有助于平衡我们的流动性方向上。",
        start_swapping: "开始交换",
        partners: "合作伙伴",
        integrations: "集成",
        oldest_channel_years: "{{ years }}年",
        oldest_channel: "最老的通道",
        capacity: "容量（{{ denomination }}）",
        peers: "对端数",
        num_channels: "通道数",
        beta_caution: "BETA - 谨慎使用！",
        pro: "pro",
        pro_banner: "想要通过 API 使用 SATS Routing Pro？",
        warning_return:
            "重要：支付发票后返回此页面！在您返回此页面之前，付款可能显示为待定。",
        warning_expiry: "确保您的交易在创建此交换后的约24小时内确认！",
        not_found: "404 - Not Found",
        not_found_subline: "此页面似乎已经消失。",
        back_to_home: "返回首页",
        transaction_prompt:
            "按“{{ button }}”以打开已连接的钱包并确认显示的交易。",
        transaction_prompt_receive: "按“{{ button }}”以开始领取 {{ asset }}。",
        transaction_failed: "交易失败：{{ error }}",
        wallet_request_rejected: "该请求已在您的钱包中被拒绝。",
        invalid_address: "无效的{{ asset }}地址",
        scan_qr_code: "扫描 QR 码",
        version: "版本",
        commithash: "提交哈希",
        open_in_wallet: "在钱包中打开",
        branding: "品牌",
        regtest: "Regtest",
        broadcasting_claim: "正在发送索赔交易...",
        paste_invalid: "剪贴板包含无效字符或超出最大金额",
        email: "邮箱",
        switch_paste: "根据粘贴的内容切换交换方向/资产",
        settings: "设置",
        decimal_separator: "小数分隔符",
        denomination_tooltip: "选择您的首选面额：BTC 或 sats",
        decimal_tooltip: "选择您的首选小数分隔符：点或逗号",
        fiat_rate_not_available: "法币汇率不可用",
        fiat_currency: "法币货币",
        fiat_currency_tooltip: "用于显示法币数值的货币",
        swap_completed: "交换{{ id }} 已成功完成！",
        claim_fail: "交换{{ id }}索赔失败！",
        logs: "日志",
        logs_tooltip: "网络应用程序的日志，用于调试",
        share_with_support: "分享给客服",
        chatwoot_not_ready:
            "客服聊天窗口正在打开——加载完成后请重新尝试分享日志。",
        hide_wallet_address: "隐私模式",
        hide_wallet_address_tooltip:
            "在演示和录屏时隐藏EVM钱包地址和交换ID以保护隐私",
        bitcoin_only: "仅比特币模式",
        bitcoin_only_tooltip: "仅显示比特币和闪电网络，隐藏所有其他交易对",
        bitcoin_only_warning:
            "仅比特币模式已启用。请在设置中关闭此模式以兑换其他资产。",
        slippage: "滑点",
        slippage_tooltip: "DEX 交换的最大价格滑点容差",
        gas_topup: "自动补充 Gas",
        gas_topup_tooltip:
            "如果您连接的钱包没有 Gas，将自动把交换的一小部分转换为原生 Gas。",
        gas_topup_label: "已包含目标链 Gas ({{ gasToken }})",
        bridge_messaging_fee: "桥接消息费用",
        bridge_transfer_fee: "桥接转账费用",
        retry: "重试",
        error_bridge_capacity: "金额超过桥接容量",
        error_no_quote: "无法获取报价。请检查您的网络连接并重试。",
        error_zero_quote: "提高发送金额",
        oft_eta: "预计约{{ time }}后到达",
        oft_eta_day_unit: "{{ value }}天",
        oft_eta_hour_unit: "{{ value }}小时",
        oft_eta_minute_unit: "{{ value }}分",
        oft_eta_second_unit: "{{ value }}秒",
        oft_arriving_soon: "即将到达...",
        oft_transfer_in_progress: "转账进行中",
        waiting_for_bridge: "等待 {{ symbol }} 桥接",
        dex_quote_changed: "DEX 报价已变更",
        commitment_rejected_line:
            "锁定的金额不足，因此无法完成此次兑换。您可以将资金退款到您的原始地址。",
        pre_bridge_dex_quote_blocked: "报价已变更",
        pre_bridge_dex_quote_blocked_line:
            "您的资金在桥接期间价格发生了变动，因此报价已不足以完成兑换。请重试，或退还您的资金。",
        recovering_bridged_funds: "正在退款...",
        pre_bridge_refund_initiated:
            "您的资金正在通过跨链桥退回到您的原始地址，将很快到账。",
        retry_quote: "重试",
        retrying_quote: "正在检查报价...",
        zero_conf: "零确认",
        zero_conf_tooltip: "接受尚未被区块确认的交易",
        on: "开",
        off: "关",
        invalid_pair: "无效交换对",
        invalid_send_asset: "无效发送资产",
        error_starting_qr_scanner: "无法访问摄像头, 请检查权限！",
        insufficient_balance: "余额不足",
        insufficient_balance_line: "您的钱包余额不足以进行此次交换。",
        insufficient_gas_balance_line:
            "您没有足够的{{ gasToken }}来为此次交换提供资金。",
        select_wallet: "选择钱包",
        select_derivation_path: "选择派生路径",
        submit_derivation_path: "提交",
        not_supported_in_browser: "此浏览器不支持",
        switch_network: "转换网络",
        block: "块",
        logs_scan_progress: "扫描进度{{ value }}%",
        logs_deriving_keys: "正在派生密钥...（目前 {{ count }} 个）",
        accept: "接受",
        wallet_connect_failed: "钱包连接失败：{{ error }}",
        ledger_open_app_prompt: "打开以太坊或 RSK 应用",
        validate_payment: "出示付款证明",
        no_browser_wallet: "未检测到浏览器钱包",
        sent: "已发送",
        will_receive: "将收到",
        refund_available_in: "退款将分 {{ blocks }} 区块提供",
        no_wallet_connected: "未连接钱包",
        no_lockup_transaction: "未找到锁仓交易",
        routing_fee_limit: "最大路由费用",
        download_boltz_rescue_key: "SATS Routing 救援密钥",
        download_boltz_rescue_key_subline: "使用单个救援密钥备份所有交换 🙌",
        download_boltz_rescue_key_subline_second:
            "此密钥可在任何设备上使用，并适用于所有用它创建的交换。",
        download_boltz_rescue_key_subline_backup: "要继续，请先备份此密钥。",
        download_boltz_rescue_key_subline_privacy:
            "**小心：**注重隐私的浏览器可能会在关闭时删除下载的文件。",
        download_boltz_rescue_key_subline_save:
            "请将救援密钥保存在**安全**且**永久**的位置！",
        download_boltz_rescue_key_subline_warning: "否则可能导致**资金损失**。",
        download_new_key: "下载救援密钥",
        verify_boltz_rescue_key: "验证博尔茨救援密钥",
        verify_boltz_rescue_key_subline:
            "请选择您之前保存的 SATS Routing 救援密钥进行验证。",
        verify_key: "验证密钥",
        verify_key_failed:
            "SATS Routing 救援密钥验证失败。我们建议下载新的 SATS Routing 救援密钥以继续。",
        rescue_key: "救援密钥",
        reset_rescue_key_tooltip: "生成新的救援密钥并清除所有交换数据",
        reset_rescue_key_prompt:
            "⚠️ 警告：这将删除所有交换数据并生成新的救援密钥。\n\n除非您有现有救援密钥的备份或绝对确定不再需要它，否则请勿继续。\n\n输入 'confirm' 以继续：",
        reset_rescue_key_invalid_confirmation:
            "确认无效。请输入 'confirm' 以继续。",
        reset_rescue_key_error:
            "重置救援密钥时出错。请重试。\n\n错误：{{ error }}",
        reset_rescue_key_success: "新的救援密钥已成功生成！",
        encrypt_rescue_key: "加密",
        decrypt_rescue_key: "移除加密",
        encrypt_rescue_key_tooltip:
            "使用密码短语对静态存储的救援密钥进行加密。您需要密码短语才能在此浏览器中解锁它。",
        set_rescue_passphrase_prompt:
            "请输入密码短语以加密静态存储的救援密钥。\n\n警告：如果您忘记此密码短语且没有救援密钥备份，您的资金将无法恢复。",
        confirm_rescue_passphrase_prompt: "请再次输入密码短语以确认：",
        rescue_passphrase_empty: "密码短语不能为空。",
        rescue_passphrase_mismatch: "密码短语不匹配。请重试。",
        encrypt_rescue_key_success: "救援密钥加密成功！",
        encrypt_rescue_key_error: "加密救援密钥时发生错误。\n\n错误：{{ error }}",
        disable_rescue_encryption_prompt:
            "移除密码短语加密并再次以明文存储救援密钥？\n\n输入 'confirm' 以继续：",
        disable_rescue_encryption_success: "加密已移除。",
        unlock_rescue_key_title: "解锁您的救援密钥",
        unlock_rescue_key_description:
            "您的救援密钥已加密。请输入密码短语以解锁并继续。",
        unlock_rescue_key_placeholder: "密码短语",
        unlock_rescue_key_button: "解锁",
        unlock_rescue_key_invalid: "密码短语无效。请重试。",
        no_swaps_found: "未找到交换",
        rif_extra_fee: "钱包中没有足够的 RBTC，费用已调整为包括 RIF 中继费！",
        back: "回一页",
        next: "下一页",
        pagination_info: "{{ start }} 的 {{ end }} 页",
        generate_key: "生成新密钥",
        show_rescue_key_instead: "改为显示 12 个单词的救援密钥",
        backup_boltz_rescue_key: "备份 SATS Routing 救援密钥",
        backup_boltz_rescue_key_subline_second:
            "这个新密钥适用于任何设备，并可用于所有用其创建的兑换操作。",
        backup_boltz_rescue_key_subline_third:
            "请记下或复制此密钥，并将其保存在安全且永久的位置。",
        backup_boltz_rescue_key_reminder: "请妥善保管。不要分享。",
        copy_rescue_key: "复制救援密钥",
        user_saved_key: "我已保存救援密钥",
        verify_mnemonic_word: {
            start: "你的救援密钥中，",
            strong: "第 {{ number }} 个",
            end: "单词是什么？",
        },
        incorrect_word: "单词不正确。请再次检查你的救援密钥。",
        enter_mnemonic: "输入救援密钥",
        verify_boltz_rescue_key_mnemonic: "请在下方输入你的救援密钥以导入。",
        hint_paste_mnemonic: "提示：你可以一次性粘贴全部 12 个单词。",
        swap_opportunities: "可用Pro机会",
        swap_opportunities_subline: "兑换这些交易对赚取聪或折扣",
        pro_fee: "Pro费率",
        regular_fee: "标准费率",
        swap_opportunities_accordion: "Pro机会",
        no_opportunities_found: {
            text: "当前无专业交易机会，请稍后再试",
            telegram_bot_text_prefix: "获取费率提醒，请查看我们的",
            telegram_bot_text_middle: "或",
            telegram_bot_text_suffix: "机器人。",
            telegram_bot: "Telegram",
            simplex: "SimpleX",
        },
        refresh_for_refund:
            "如果您向本次交换发送了比特币，请刷新页面检查是否有退款。",
        applied_routing_hint:
            "你的收款人支持直接接收 {{ asset }}。这为你节省了手续费，且对方仍会收到全额款项。",
        optimized_route_amount:
            "交换路径已优化，为你节省了约 {{ amount }} {{ denomination }}",
        claim: "索赔",
        claimed: "交换已成功索赔！",
        rescue: "救援",
        rescue_swaps: "救援交换",
        rescue_swap: "救援交换",
        failed_get_swap: "无法获取交换 {{ id }}",
        failed_get_swap_subline: "请重新插入救援钥匙并再次尝试。",
        in_progress: "进行中",
        completed: "已完成",
        get_refundable_error:
            "无法加载 UTXO 数据。请刷新页面后重试，或检查您的网络连接如果问题仍然存在。",
        min_amount_destination:
            "目标地址的最小金额为{{ amount }}{{ denomination }}",
        max_amount_destination:
            "目标地址的最大金额为{{ amount }}{{ denomination }}",
        exact_amount_destination:
            "发票金额必须正好为{{ amount }}{{ denomination }}",
        destination: "目标地址",
        destination_address: "{{ address }}",

        // Products page
        products: "产品",
        products_description: "一套产品，可实现比特币各层之间的无缝互操作性",
        products_plugin_title: "SATS Routing BTCPay 插件",
        products_plugin_description:
            "一种非托管解决方案，无需运行 Lightning 节点即可轻松接受 Lightning 支付",
        products_client_title: "SATS Routing 客户端",
        products_client_description:
            "我们的企业级交换守护程序，用于服务器集成和流动性管理",
        products_pro_title: "SATS Routing Pro",
        products_pro_description: "通过交换赚取聪的平台",
        learn_more: "了解更多",
        get_started: "打开 SATS Routing Pro",
        documentation: "文档",
        view_on_github: "在 Github 上查看",
        chat_with_us: "与我们聊天",

        // Plugin
        boltz_plugin_name: "SATS Routing BTCPay 插件",
        boltz_plugin_description: "非托管解决方案，轻松接受 Lightning 支付",
        boltz_plugin_step_install_title: "添加插件",
        boltz_plugin_step_install_description:
            "在您的 BTCPay 服务器上安装 SATS Routing 插件",
        boltz_plugin_step_setup_title: "设置您的钱包",
        boltz_plugin_step_setup_description: "连接您的外部钱包或创建一个新钱包",
        boltz_plugin_step_paid_title: "接受 Lightning",
        boltz_plugin_step_paid_description:
            "接收自动结算到主链比特币的 Lightning 支付",
        boltz_plugin_features_title: "为什么使用它？",
        boltz_plugin_features_description:
            "专为希望在没有复杂性的情况下拥有完全控制权的商家而构建",
        boltz_plugin_feature_flexible_title: "灵活",
        boltz_plugin_feature_flexible_description:
            "无需运行节点即可接受 Lightning 支付，或完全管理现有 Lightning 节点的流动性",
        boltz_plugin_feature_liquid_title: "由 Liquid 驱动",
        boltz_plugin_feature_liquid_description:
            "充分利用 Liquid Taproot 交换的强大功能，实现低费用和增强的隐私",
        boltz_plugin_feature_autoswap_title: "在比特币上结算",
        boltz_plugin_feature_autoswap_description:
            "根据您的偏好自动交换到主链比特币",
        boltz_plugin_feature_self_custodial_title: "非托管",
        boltz_plugin_feature_self_custodial_description:
            "保持对您的比特币的完全控制，由 SATS Routing 原子交换提供支持",

        boltz_plugin_questions_title: "有问题？",
        boltz_plugin_questions_subtitle: "我们很乐意听取您的意见！",
        // Client
        boltz_client_name: "SATS Routing 客户端",
        boltz_client_description:
            "企业级交换守护程序，用于服务器集成和流动性管理",
        boltz_client_features_title: "专为企业和专业人士打造",
        boltz_client_features_description:
            "为专业 Lightning 节点运营商设计的强大功能",
        boltz_client_feature_taproot_title: "Taproot 优先",
        boltz_client_feature_taproot_description:
            "利用 Taproot 交换提高效率和隐私",
        boltz_client_node_agnostic_title: "节点不可知",
        boltz_client_node_agnostic_description:
            "除 LND 外还提供对 CLN 的一流支持，让您在基础设施中拥有灵活性",
        boltz_client_autoswap_title: "智能自动交换",
        boltz_client_autoswap_description:
            "细粒度控制自动通道再平衡，具有可自定义的配置和比特币智能结算",
        boltz_client_liquid_title: "Liquid 优先",
        boltz_client_liquid_description:
            "针对使用 Liquid 交换进行通道再平衡进行了优化，实现低费用、快速执行和增强隐私",
        boltz_client_cli_title: "强大的 API 和 CLI",
        boltz_client_cli_first_paragraph:
            "内置钱包系统和全面的 API，可无缝集成到您的基础设施中。",
        boltz_client_cli_second_paragraph:
            "通过您自己的应用程序或 CLI 监控、控制和自动化。",
        boltz_client_cta_title: "将 SATS Routing 添加到您的基础设施！",
        boltz_client_cta_subtitle:
            "加入使用 SATS Routing Client 的企业和节点运营商社区",

        // Pro
        boltz_pro_name: "SATS Routing Pro",
        boltz_pro_description: "通过交换赚取聪的平台",
        boltz_pro_how_it_works_title: "工作原理",
        boltz_pro_how_it_works_description:
            "您通过进行帮助我们再平衡流动性方向的交换而获得报酬",
        boltz_pro_chart_title: "SATS Routing Pro 费用历史样本",
        boltz_pro_chart_y_axis: "SATS Routing Pro 费用",
        boltz_pro_chart_x_axis: "日期",
        boltz_pro_negative_fee: "您赚取聪",
        boltz_pro_lower_fee: "您节省聪",
        boltz_pro_regular_fee: "常规 SATS Routing 费用",
        boltz_pro_target_audience_title: "SATS Routing Pro 适合谁？",
        boltz_pro_target_audience_subtitle:
            "专为想要赚取聪的专业人士打造，而不是日常支付",
        boltz_pro_perfect_for_title: "适用于",
        boltz_pro_perfect_for_1:
            "希望减少过多入站流动性以赚取聪的 Lightning 节点运营商",
        boltz_pro_perfect_for_2: "与外部节点运营商合作管理流动性的专业人士",
        boltz_pro_perfect_for_3:
            "在 SATS Routing Pro 路由限制内充值 Lightning 钱包的用户",
        boltz_pro_not_designed_for_title: "不适合",
        boltz_pro_not_designed_for_1: "日常 Lightning 支付，如购买咖啡",
        boltz_pro_not_designed_for_2: "向具有高路由费用的目的地进行可靠支付",
        boltz_pro_not_designed_for_3: "需要保证即时支付执行的场景",
        boltz_pro_cta_title: "立即开始赚取聪！",
        boltz_pro_cta_subtitle: "探索当前赚取聪的机会",
        boltz_pro_options_title: "使用 SATS Routing Pro 的 3 种方式",
        boltz_pro_options_subtitle: "选择最适合您的方式",
        boltz_pro_option_client_title: "SATS Routing 客户端",
        boltz_pro_option_client_description:
            "通过 API 和 CLI 完全自动化 SATS Routing Pro",
        boltz_pro_option_web_title: "网络应用",
        boltz_pro_option_web_description:
            "使用我们的 SATS Routing Pro 网络应用观察和交换",
        boltz_pro_option_chat_title: "聊天机器人",
        boltz_pro_option_chat_description_prefix: "在",
        boltz_pro_option_chat_description_middle: "或",
        boltz_pro_option_chat_description_suffix:
            "中接收有关 SATS Routing Pro 机会的即时提醒。",

        balance: "余额",
        display: "显示",
        security: "安全",
        failed: "失败",
        swaps_found: "正在扫描交换（已找到 {{ count }} 个）",
        claim_scan_required: "要领取此交换，请返回并在上传救援文件后进行扫描。",
        refund_scan_required:
            "要退还此余额，请返回并在上传救援文件后进行扫描。",
        refund_destination_hint:
            "资金将以 {{ symbol }} 的形式在 {{ network }} 上退还到你连接的 EVM 钱包。",
        invalid_rescue_key_evm:
            "此救援密钥与此交换不关联。请使用其他救援密钥重试。",
        error_occurred: "发生错误：{{ error }}",
        rescue_external_select_method: "至少选择一种救援方式",
        rescue_external_subtitle: "使用此页面救援历史标签页中不可用的交换。",
        rescue_external_report_issue_start:
            "如果您认为您的交换因我们方面的问题而失败，请",
        rescue_external_report_issue_link: "点击此处",
        rescue_external_report_issue_end:
            "分享日志并向我们提供有关您交换的一些详细信息。",
        rescue_external_coverage: "可使用已提供的救援方式救援",
        rescue_external_requires_rescue_key: "需要救援密钥",
        rescue_external_requires_wallet: "需要钱包",
        rescue_external_requires_rescue_key_wallet: "需要救援密钥和钱包",
        rescue_external_resume: "继续",
        evm_rescue_prompt:
            "如果你向 EVM 链上的 SATS Routing 交换发送了资金，请使用“退还交换”；如果你正在从 EVM 链接收资金，请使用“继续交换”，以救援一个未在此浏览器交换历史中显示的交换。",
        evm_rescue_refund_title: "退还交换",
        start_scanning: "开始扫描",
        stop_scanning: "停止扫描",
        evm_rescue_resume_title: "继续交换",
        evm_rescue_resume_explainer:
            "使用你的救援密钥查找可以继续的待处理交换。",
        unmatched_swaps:
            "该钱包有 {{ count }} 个额外可领取的交换。要访问它们，请切换到用于发起这些交换的救援密钥。",
        approve: "授权",
        approve_allowance_line: "为交换合约设置 {{ tokenStandard }} 授权额度",
        approve_allowance_reset_line:
            "某些 {{ tokenStandard }} 代币要求先将授权额度重置为 0，然后才能设置新的额度。你可能需要授权两次。",
        upload_rescue_key: "选择救援密钥",

        suspension_status: "兑换服务已停用",
        suspension_p1: "更新：SATS Routing 将持续停用，直至另行通知。",
        suspension_p2:
            "我们的 API 仍可用于协作处理退款。无论如何，单方面退款都能正常进行，因为它们不依赖我们的基础设施。",
        suspension_p3: "我们的支持团队仍可联系。",
        suspension_p4:
            "需要说明的是：这并非针对单一事件的回应。过去几个月，我们看到针对基础设施的自动化、AI 辅助探测持续增加，并处理了多起漏洞利用。每一起都已被控制，但模式已经很清楚：攻击者的迭代速度已超过我们这种规模的团队发现和修补的速度。仅在最近几天，我们就看到了急剧的加速，我们并不认为这种不对称会逆转。在审视了我们自己近期安全扫描的结果后，我们无法负责任地重新启用 SATS Routing 兑换，尤其是在我们正被看似多个资源充足的团伙主动锁定、而我们仍在争分夺秒部署修复的情况下。",
        suspension_p5:
            "我们所看到的，是基于开源技术栈运行的比特币服务所面临的一次重大范式转变，这需要审慎分析。请不要期待兑换服务会很快恢复。",
        suspension_p6:
            "明确地说：用户资金从未面临风险。SATS Routing 在设计上就是非托管的。作为一家完全自筹资金的公司，损失全部由我们自己承担。",
        suspension_p7:
            "我们尚不清楚接下来会如何发展，但一旦我们有时间喘口气并做出决定，就会及时告知大家 🙏",
        suspension_date: "2026年8月3日 · 在 X 上查看",
    },
    ja: {
        language: "日本語",
        or: "または",
        status: "ステータス",
        fast: "高速",
        l2: "L2技術を活用",
        l2_sub: "SATS Routingは、LiquidネットワークやLightningネットワークなどのL2スケーリング技術を利用しています",
        assets_sub: "ビットコインレイヤー",
        safe: "安全",
        non_custodial: "ノンカストディアル型",
        non_custodial_sub:
            "SATS Routingのスワップはノンカストディアル型です。暗号技術により、ユーザーは常に資金を自己管理できます",
        node: "ノード",
        error: "エラー",
        error_subline: "APIからの無効な応答です。何かが間違っています",
        error_wasm: "WebAssemblyはサポートされていません",
        history: "履歴",
        swap: "スワップ",
        refund: "返金",
        partner: "パートナー",
        support: "ヘルプ",
        docs: "ドキュメント",
        onion: "Onion",
        terms: "利用規約",
        privacy: "プライバシー",
        blockexplorer: "ブロックエクスプローラーで表示{{ typeLabel }}",
        blockexplorer_lockup_address: "ロックアップアドレス",
        blockexplorer_lockup_tx: "ロックアップトランザクション",
        blockexplorer_claim_tx: "要求トランザクション",
        blockexplorer_refund_tx: "返金トランザクション",
        check_bridge_status: "ブリッジステータスを確認",
        help: "ヘルプ",
        network_fee: "ネットワーク手数料",
        swap_fees: "スワップ手数料",
        fee: "SATS Routing手数料",
        denomination: "単位",
        send: "送信",
        checking_previous_transaction: "前回のトランザクションを確認中",
        checking_previous_transaction_line:
            "ウォレットがブリッジトランザクションを送信したか確認しています。しばらくお待ちください。",
        could_not_confirm_previous_transaction:
            "前回のトランザクションを確認できませんでした",
        could_not_confirm_previous_transaction_line:
            "ウォレットがブリッジトランザクションを送信したか確認できませんでした。",
        checking_previous_transaction_countdown: "残り {{ seconds }} 秒。",
        check_again: "再確認",
        did_not_send_transaction: "トランザクションを送信していません",
        did_not_send_transaction_confirm:
            "ウォレットがトランザクションを送信していないことが確実な場合のみ続行してください。続行すると、資金を二重に送信する可能性があります。",
        continue: "続ける",
        receive: "受取",
        max: "最大",
        minimum_amount: "最小金額は{{ amount }} {{ denomination }}です",
        maximum_amount: "最大金額は{{ amount }} {{ denomination }}です",
        assets: "アセット",
        footer: "SATS Routingによる🧡で作成されました",
        create_swap: "Swapの作成",
        get_gas_token_for_gas: "{{ gasToken }}をガス代として取得",
        new_swap: "新しいスワップ",
        feecheck:
            "ネットワーク手数料はネットワーク状況に基づいて更新されました。新しい金額を確認し、スワップを続行してください",
        amount_limits_changed:
            "スワップの上限／下限が変更されました。新しい金額を確認し、スワップを続行してください。",
        commitment_invoice_heading:
            "{{ amount }} {{ denomination }} のライトニングインボイスを入力してください",
        commitment_invoice_deferred: "支払い後にライトニングの送金先を入力",
        clear_amount: "クリア",
        create_and_paste:
            "資金を受け取るために、ライトニングインボイス、BOLT12、またはLNURLを貼り付けてください",
        invoice_cleared_amount_changed:
            "金額が変更されたためインボイスをクリアしました。",
        congrats: "おめでとうございます！",
        successfully_swapped: "スワップが正常に完了しました",
        bridge_transfer_pending:
            "スワップが完了しました！{{ amount }} {{ denomination }} は {{ network }} ブリッジ経由で送信されました。ブリッジ転送の完了には数分かかる場合があります。",
        timeout_eta: "タイムアウト予想時間",
        pay_invoice: "スワップ：{{ id }}",
        pay_swap_404: "スワップが見つかりません！",
        pay_timeout_blockheight: "タイムアウトブロック高 ({{ network }})",
        send_to:
            "{{ amount }} {{ denomination }} を以下のアドレスへ送金して下さい",
        send_between:
            "{{ min }} から {{ max }} {{ denomination }} を送信してください",
        pay_invoice_to:
            "このインボイスを支払う {{ amount }} {{ denomination }}",
        no_wallet: "ウォレットがインストールされていません",
        connect_wallet: "ウォレットの接続",
        please_connect_wallet: "ウォレットを接続してください",
        connect_to_address: "スワップアドレスに接続",
        disconnect_address: "ウォレットの接続を",
        lockup_failed: "ロックアップに失敗しました！",
        failure_reason: "失敗の理由",
        invoice_payment_failure: "インボイスを支払うことができませんでした",
        onchain_address:
            "資金を受け取るために、{{ asset }}アドレスを入力してください",
        onchain_address_no_asset: "アドレスを入力してください",
        invalid_refund_file: "無効なレスキューキー",
        invalid_invoice: "有効なインボイス、BOLT12、LNURLを入力してください",
        invalid_0_amount: "金額のない空インボイスは対応していません",
        copy_invoice: "インボイスをコピー",
        copy_address: "アドレスをコピー",
        copy_amount: "金額をコピー",
        copy_bip21: "BIP21をコピー",
        rescue_a_swap_subline:
            "BTCまたはLBTCをSATS Routingスワップに送金した場合、このブラウザのスワップ履歴に表示されないスワップを復旧するには、復旧キーをアップロードまたは入力してください。",
        rescue_a_swap_mnemonic:
            "このブラウザの交換履歴にない交換を復元するには、復元キーを入力してください。",
        refund_past_swaps: "過去のスワップ",
        refund_past_swaps_subline: "ブラウザのストレージに保存されたスワップ",
        no_rescuable_swaps:
            "ブラウザの履歴に復元可能なスワップが見つかりませんでした。",
        refund_external_scanning_evm:
            "EVM チェーン上の復旧可能なスワップを検索中です...",
        connected_wallet_no_swaps:
            "接続されたRootstockウォレットには、復元可能なスワップは含まれていません。",
        history_no_swaps: "まだスワップを行っていないようです。",
        refund_address_header:
            "返金用の {{ asset }} ウォレットのアドレスを入力",
        refund_address_header_no_asset: "返金用のウォレットのアドレスを入力",
        history_export: "エクスポート",
        refund_clear: "ローカルストレージを削除",
        delete_storage:
            "ストレージを削除しても本当にいいですか？\n スワップ情報と、返金、クレーム用の秘密鍵は失われます",
        delete_storage_single_swap:
            "ストレージからスワップ {{ id }} を削除しても本当にいいですか？ \n スワップ情報と、返金、クレーム用の秘密鍵は失われます",
        delete_logs: "ログを削除しても本当にいいですか？",
        tx_in_mempool: "トランザクションがメモリプール内にあります",
        tx_in_mempool_subline: "スワップを完了するために確認を待っています",
        tx_in_mempool_warning:
            "ページを開いたままにしないと、スワップは完了しません！",
        invoice_pending:
            "トランザクションを受け取りました。インボイスを支払っています",
        invoice_pending_pro:
            "トランザクションを受け取りました。インボイスはキューに入りました。場合によっては、スワップがキャンセルされることがあります。",
        invoice_expired:
            "インボイスの有効期限が切れました。もう一度試してください",
        create_invoice_webln: "WebLNを使用してインボイスを作成",
        pay_invoice_webln: "WebLNを使用してインボイスを支払う",
        select_asset_send: "送信アセットを選択",
        select_asset_receive: "受信アセットを選択",
        select_network: "ネットワークを選択",
        search: "検索",
        tx_confirmed: "トランザクションが確認されました",
        tx_ready_to_claim: "トランザクションを実行中...",
        refunded: "このスワップを返金しました",
        refunded_bridge_pending:
            "スワップを返金しました。{{ denomination }} は {{ network }} へブリッジで返金中で、到着まで時間がかかる場合があります。",
        locktime_not_satisfied: "ロックタイムの条件を満たしていません",
        already_refunded: "スワップはすでに返金されています",
        api_offline: "APIがオフラインです",
        api_offline_msg:
            "SATS Routing APIに接続できませんでした。後でもう一度お試しください",
        refund_explainer: "タイムアウト後に返金できます!",
        wasm_not_supported: "ブラウザでWebAssemblyを有効にしてください",
        created: "作成済み",
        view: "表示",
        id: "ID",
        headline:
            "プライバシーファースト、ノンカストディアル型のビットコイン取引所",
        headline_pro: "聪を積み上げる、非托管で！",
        subline:
            "異なるビットコインレイヤーの間で、完全な管理を保ちながらスワップ。",
        subline_pro:
            "ビットコインをスワップするためサットを稼ぐ、私たちの流動性を調整する方向で。",
        start_swapping: "取引を開始する",
        partners: "パートナー",
        integrations: "インテグレーション",
        oldest_channel_years: "{{ years }}年",
        oldest_channel: "最古のチャネル",
        capacity: "容量（サトシ）",
        peers: "ピアの数",
        num_channels: "チャネルの数",
        beta_caution: "ベータ版の為、ご利用は慎重にお願いします",
        pro: "pro",
        pro_banner: "API経由でSATS Routing Proを使用したいですか？",
        warning_return:
            "重要：インボイスのお支払い後、このページへ戻ってください！このページに戻るまで、支払いは保留中と表示される場合があります。",
        warning_expiry:
            "必ず24時間以内にトランザクションが承認されるようにしてください",
        not_found: "404 - Not Found",
        not_found_subline: "このページは消えてしまったようです。",
        back_to_home: "ホームに戻る",
        transaction_prompt:
            " 接続したウォレットを開いて、表示されたトランザクションを確認するために　{{ button }} を押してください",
        transaction_prompt_receive:
            "{{ asset }} の請求を開始するには {{ button }} を押してください",
        transaction_failed: "トランザクションに失敗しました: {{ error }}",
        wallet_request_rejected: "ウォレットでリクエストが拒否されました。",
        invalid_address: "無効な {{ asset }} アドレス",
        scan_qr_code: "QRコードをスキャンする",
        version: "バージョン",
        commithash: "コミットハッシュ",
        open_in_wallet: "ウォレットで開く",
        branding: "ブランディング",
        regtest: "Regtest",
        broadcasting_claim: "クレームトランザクションのブロードキャスト中",
        paste_invalid:
            "クリップボードに無効な文字が含まれるか、最大文字数を超えています",
        email: "Eメール",
        switch_paste: "スワップの方向性/アセットを変更しました",
        settings: "設定",
        decimal_separator: "小数点",
        denomination_tooltip: "希望する単位を選択してください：BTCもしくはSats",
        decimal_tooltip:
            "希望する小数点を選択してください：ドットもしくはコンマ",
        fiat_rate_not_available: "法定通貨レートを取得できません",
        fiat_currency: "法定通貨",
        fiat_currency_tooltip: "法定通貨換算に使用する通貨",
        swap_completed: " スワップ {{ id }} が無事に成功しました!",
        claim_fail: "クレームのスワップに失敗しました: {{ id }}",
        logs: "ログ",
        logs_tooltip: "ウェブアプリのログ。デバグに便利です",
        share_with_support: "サポートに共有する",
        chatwoot_not_ready:
            "サポートチャットを開いています。読み込みが完了したら、もう一度ログの共有をお試しください。",
        hide_wallet_address: "プライバシーモード",
        hide_wallet_address_tooltip:
            "デモや録画時のプライバシー保護のため、EVMウォレットアドレスとスワップIDを非表示にします",
        bitcoin_only: "ビットコイン専用モード",
        bitcoin_only_tooltip:
            "ビットコインとライトニングのみを表示し、他のすべてのペアを非表示にします",
        bitcoin_only_warning:
            "ビットコイン専用モードが有効です。他の資産をスワップするには、設定で無効にしてください。",
        slippage: "スリッページ",
        slippage_tooltip: "DEXスワップで許容する最大価格スリッページ",
        gas_topup: "ガス自動チャージ",
        gas_topup_tooltip:
            "接続されたウォレットにガスがない場合、スワップの一部を自動的にネイティブガスに変換します。",
        gas_topup_label: "宛先ガス ({{ gasToken }}) を含む",
        bridge_messaging_fee: "ブリッジメッセージ手数料",
        bridge_transfer_fee: "ブリッジ転送手数料",
        retry: "再試行",
        error_bridge_capacity: "金額がブリッジ容量を超えています",
        error_no_quote:
            "見積もりを取得できませんでした。接続を確認してもう一度お試しください。",
        error_zero_quote: "送信額を増やす",
        oft_eta: "到着予定 約{{ time }}",
        oft_eta_day_unit: "{{ value }}日",
        oft_eta_hour_unit: "{{ value }}時間",
        oft_eta_minute_unit: "{{ value }}分",
        oft_eta_second_unit: "{{ value }}秒",
        oft_arriving_soon: "まもなく到着...",
        oft_transfer_in_progress: "転送中",
        waiting_for_bridge: "{{ symbol }}ブリッジを待機中",
        dex_quote_changed: "DEXのクオートが変更されました",
        commitment_rejected_line:
            "ロックされた金額が不足しているため、このスワップを完了できません。資金を元のアドレスに返金できます。",
        pre_bridge_dex_quote_blocked: "見積もりが変更されました",
        pre_bridge_dex_quote_blocked_line:
            "ブリッジ中に価格が変動したため、見積もりではスワップを完了できなくなりました。もう一度お試しいただくか、資金を返金してください。",
        recovering_bridged_funds: "返金中...",
        pre_bridge_refund_initiated:
            "資金は元のアドレスへブリッジ経由で返金されており、まもなく着金します。",
        retry_quote: "再試行",
        retrying_quote: "クオートを確認しています...",
        zero_conf: "ゼロ確認",
        zero_conf_tooltip: "ブロック内でまだ確認されていない取引を受け入れる",
        on: "オン",
        off: "オフ",
        invalid_pair: "無効なペア",
        invalid_send_asset: "無効な送信アセット",
        error_starting_qr_scanner:
            "カメラにアクセスできませんでした。権限を確認してください！",
        insufficient_balance: "残高不足",
        insufficient_balance_line:
            "このスワップを実行するのに十分な残高がウォレットにありません",
        insufficient_gas_balance_line:
            "このスワップの資金に必要な{{ gasToken }}が不足しています。",
        select_wallet: "ウォレットの選択",
        select_derivation_path: "導出パスの選択",
        submit_derivation_path: "提出",
        not_supported_in_browser: "このブラウザには対応していません",
        switch_network: "ネットワークの切り替え",
        block: "ブロック",
        logs_scan_progress: " 進捗度 {{ value }}%",
        logs_deriving_keys: "キーを導出中...（現在 {{ count }} 件）",
        accept: "受入れる",
        wallet_connect_failed: "ウォレット接続の失敗: {{ error }}",
        ledger_open_app_prompt: "イーサリアムもしくはRSKのアプリを開く",
        validate_payment: "支払い証明書の提示",
        no_browser_wallet: "ブラウザのウォレットが検出されない",
        sent: "送信済み",
        will_receive: "受信予定",
        refund_available_in: "返金は {{ blocks }} つのブロックに分かれる",
        no_wallet_connected: "財布はつながっていない！",
        no_lockup_transaction: "ロックアップトランザクションが見つかりません",
        routing_fee_limit: "ルーティング料金の上限",
        download_boltz_rescue_key: "SATS Routingレスキューキー",
        download_boltz_rescue_key_subline:
            "1つのレスキューキーですべてのスワップをバックアップ 🙌",
        download_boltz_rescue_key_subline_second:
            "このキーはどのデバイスでも使用でき、このキーで作成されたすべてのスワップに対応します。",
        download_boltz_rescue_key_subline_backup:
            "続行するには、このキーをバックアップしてください。",
        download_boltz_rescue_key_subline_privacy:
            "**ご注意:**プライバシー重視のブラウザでは、閉じたときにダウンロードしたファイルが削除される場合があります。",
        download_boltz_rescue_key_subline_save:
            "レスキューキーは**安全**で**永続的**な場所に保管してください！",
        download_boltz_rescue_key_subline_warning:
            "そうしないと、**資金の損失**につながる可能性があります。",
        download_new_key: "レスキューキーをダウンロード",
        verify_boltz_rescue_key: "SATS Routingレスキューキー検証",
        verify_boltz_rescue_key_subline:
            "以前にダウンロードしたSATS Routingレスキューキーを選択して確認してください。",
        verify_key: "ベリファイキー",
        verify_key_failed:
            "SATS Routingレスキューキーの検証に失敗しました。続行するには、新しいSATS Routingレスキューキーをダウンロードすることをお勧めします。",
        rescue_key: "レスキューキー",
        reset_rescue_key_tooltip:
            "新しいレスキューキーを生成し、すべてのスワップデータを削除",
        reset_rescue_key_prompt:
            "⚠️ 警告：これにより、すべてのスワップデータが削除され、新しいレスキューキーが生成されます。\n\n既存のレスキューキーのバックアップがある場合、または絶対に必要ないと確信している場合を除き、続行しないでください。\n\n続行するには 'confirm' と入力してください：",
        reset_rescue_key_invalid_confirmation:
            "無効な確認です。続行するには 'confirm' と入力してください。",
        reset_rescue_key_error:
            "レスキューキーのリセット中にエラーが発生しました。もう一度お試しください。\n\nエラー：{{ error }}",
        reset_rescue_key_success:
            "新しいレスキューキーが正常に生成されました！",
        encrypt_rescue_key: "暗号化",
        decrypt_rescue_key: "暗号化を解除",
        encrypt_rescue_key_tooltip:
            "パスフレーズでレスキューキーを保存時に暗号化します。このブラウザでロック解除するにはパスフレーズが必要です。",
        set_rescue_passphrase_prompt:
            "レスキューキーを保存時に暗号化するためのパスフレーズを入力してください。\n\n警告：このパスフレーズを忘れ、レスキューキーのバックアップがない場合、資金を復元できなくなります。",
        confirm_rescue_passphrase_prompt:
            "確認のためパスフレーズを再入力してください：",
        rescue_passphrase_empty: "パスフレーズを空にすることはできません。",
        rescue_passphrase_mismatch:
            "パスフレーズが一致しません。もう一度お試しください。",
        encrypt_rescue_key_success:
            "レスキューキーの暗号化に成功しました！",
        encrypt_rescue_key_error:
            "レスキューキーの暗号化中にエラーが発生しました。\n\nエラー：{{ error }}",
        disable_rescue_encryption_prompt:
            "パスフレーズによる暗号化を解除し、レスキューキーを再び平文で保存しますか？\n\n'confirm' と入力して続行してください：",
        disable_rescue_encryption_success: "暗号化を解除しました。",
        unlock_rescue_key_title: "レスキューキーのロック解除",
        unlock_rescue_key_description:
            "レスキューキーは暗号化されています。パスフレーズを入力してロックを解除し、続行してください。",
        unlock_rescue_key_placeholder: "パスフレーズ",
        unlock_rescue_key_button: "ロック解除",
        unlock_rescue_key_invalid:
            "パスフレーズが無効です。もう一度お試しください。",
        no_swaps_found: "スワップが見つからない",
        rif_extra_fee:
            "ウォレットに十分なRBTCがないため、RIFリレー手数料を含めて手数料を調整！",
        back: "戻る",
        next: "次へ",
        pagination_info: "{{ end }} ページ中 {{ start }} ページ目",
        generate_key: "新しいキーを生成",
        show_rescue_key_instead: "代わりに12語のレスキューキーを表示",
        backup_boltz_rescue_key: "SATS Routingレスキューキーのバックアップ",
        backup_boltz_rescue_key_subline_second:
            "この新しいキーはどのデバイスでも動作し、このキーで作成されたすべてのスワップに対応します。",
        backup_boltz_rescue_key_subline_third:
            "キーファイルを安全で永続的な場所に保管してください。",
        backup_boltz_rescue_key_reminder:
            "安全に保管してください。共有しないでください。",
        copy_rescue_key: "レスキューキーをコピー",
        user_saved_key: "レスキューキーを保存しました",
        verify_mnemonic_word: {
            start: "あなたのレスキューキーの",
            strong: "{{ number }}番目の単語",
            end: "は何ですか？",
        },
        incorrect_word:
            "間違った単語です。レスキューキーを再確認してください。",
        enter_mnemonic: "レスキューキーを入力",
        verify_boltz_rescue_key_mnemonic:
            "下にレスキューキーを入力してインポートしてください。",
        hint_paste_mnemonic:
            "ヒント：12個の単語を一度に貼り付けることができます。",
        swap_opportunities: "可能なProの機会",
        swap_opportunities_subline:
            "これらのペアをスワップしてサトシを獲得または割引を受ける",
        pro_fee: "Pro料金",
        regular_fee: "通常料金",
        swap_opportunities_accordion: "Pro機会",
        no_opportunities_found: {
            text: "現在利用可能なPro機会はありません。後ほど再度確認してください。。",
            telegram_bot_text_prefix: "手数料アラートは、",
            telegram_bot_text_middle: "または",
            telegram_bot_text_suffix: "のボットをご確認ください。",
            telegram_bot: "Telegram",
            simplex: "SimpleX",
        },
        refresh_for_refund:
            "このスワップにビットコインを送金した場合は、ページを更新して払い戻しを確認してください。",
        applied_routing_hint:
            "受取人は{{ asset }}の直接受け取りに対応しています。これにより手数料が節約でき、相手は引き続き全額を受け取ります。",
        optimized_route_amount:
            "スワップ経路が最適化され、約{{ amount }} {{ denomination }}を節約できました。",
        claim: "クレーム",
        claimed: "スワップが正常にクレームされました！",
        rescue: "救済",
        rescue_swaps: "スワップを救済",
        rescue_swap: "スワップを救済",
        failed_get_swap: "スワップ {{ id }} を取得できませんでした",
        failed_get_swap_subline:
            "レスキューキーを再挿入し、もう一度お試しください。",
        in_progress: "進行中",
        completed: "完了",
        get_refundable_error:
            "UTXO データの読み込みに失敗しました。ページを更新して再試行するか、問題が続く場合はインターネット接続を確認してください。",
        min_amount_destination:
            "宛先アドレスの最小金額は{{ amount }} {{ denomination }}です",
        max_amount_destination:
            "宛先アドレスの最大金額は{{ amount }} {{ denomination }}です",
        exact_amount_destination:
            "インボイスの金額は正確に{{ amount }} {{ denomination }}である必要があります",
        destination: "宛先アドレス",
        destination_address: "{{ address }}",

        // Products page
        products: "製品",
        products_description:
            "Bitcoinレイヤー間のシームレスな相互運用性を実現する製品スイート",
        products_plugin_title: "SATS Routing BTCPayプラグイン",
        products_plugin_description:
            "Lightningノードを実行せずに簡単にLightning決済を受け入れるノンカストディアルソリューション",
        products_client_title: "SATS Routingクライアント",
        products_client_description:
            "サーバー統合とリクイディティ管理のための当社のエンタープライズグレードのスワップデーモン",
        products_pro_title: "SATS Routing Pro",
        products_pro_description: "スワップでsatsを稼げるプラットフォーム",
        learn_more: "詳細を見る",
        get_started: "SATS Routing Proを開く",
        documentation: "ドキュメント",
        view_on_github: "Githubで見る",
        chat_with_us: "チャットする",

        // Plugin
        boltz_plugin_name: "SATS Routing BTCPayプラグイン",
        boltz_plugin_description:
            "Lightning決済を簡単に受け入れるノンカストディアルソリューション",
        boltz_plugin_step_install_title: "プラグインを追加",
        boltz_plugin_step_install_description:
            "BTCPayサーバーにSATS Routingプラグインをインストールする",
        boltz_plugin_step_setup_title: "ウォレットを設定",
        boltz_plugin_step_setup_description:
            "外部ウォレットを接続するか、新しいウォレットを作成する",
        boltz_plugin_step_paid_title: "Lightningを受け入れる",
        boltz_plugin_step_paid_description:
            "メインチェーンBitcoinに自動決済されるLightning決済を受け取る",
        boltz_plugin_features_title: "なぜ使うのか？",
        boltz_plugin_features_description:
            "複雑さなしに完全なコントロールを求めるマーチャントのために構築",
        boltz_plugin_feature_flexible_title: "柔軟",
        boltz_plugin_feature_flexible_description:
            "ノードを実行せずにLightning決済を受け入れるか、既存のLightningノードのリクイディティを完全に管理する",
        boltz_plugin_feature_liquid_title: "Liquidで駆動",
        boltz_plugin_feature_liquid_description:
            "低手数料と高いプライバシーのためにLiquid Taproot Swapsのパワーを完全に活用",
        boltz_plugin_feature_autoswap_title: "Bitcoinで決済",
        boltz_plugin_feature_autoswap_description:
            "設定に基づいてメインチェーンBitcoinへ自動スワップ",
        boltz_plugin_feature_self_custodial_title: "ノンカストディアル",
        boltz_plugin_feature_self_custodial_description:
            "SATS Routing Atomic Swapsによって駆動され、Bitcoinの完全なコントロールを維持",

        boltz_plugin_questions_title: "質問がありますか？",
        boltz_plugin_questions_subtitle: "ぜひお聞かせください！",
        // Client
        boltz_client_name: "SATS Routingクライアント",
        boltz_client_description:
            "サーバー統合とリクイディティ管理のためのエンタープライズグレードのスワップデーモン",
        boltz_client_features_title: "企業とプロフェッショナル向けに構築",
        boltz_client_features_description:
            "プロフェッショナルLightningノードオペレーター向けに設計された強力な機能",
        boltz_client_feature_taproot_title: "Taproot優先",
        boltz_client_feature_taproot_description:
            "効率性とプライバシーの向上のためにTaproot Swapsを活用",
        boltz_client_node_agnostic_title: "ノード非依存",
        boltz_client_node_agnostic_description:
            "LNDに加えてCLNへのファーストクラスサポート、インフラストラクチャにおける柔軟性を提供",
        boltz_client_autoswap_title: "インテリジェント自動スワップ",
        boltz_client_autoswap_description:
            "カスタマイズ可能な設定とBitcoinでのスマート決済を備えた自動チャネル再バランシングの細かい制御",
        boltz_client_liquid_title: "Liquid優先",
        boltz_client_liquid_description:
            "低手数料、高速実行、プライバシー強化のためにLiquidスワップを使用したチャネル再バランシングに最適化",
        boltz_client_cli_title: "強力なAPIとCLI",
        boltz_client_cli_first_paragraph:
            "インフラストラクチャへのシームレスな統合のための組み込みウォレットシステムと包括的なAPI。",
        boltz_client_cli_second_paragraph:
            "独自のアプリケーションまたはCLI経由で監視、制御、自動化。",
        boltz_client_cta_title: "インフラストラクチャにSATS Routingを追加！",
        boltz_client_cta_subtitle:
            "SATS Routing Clientを使用している企業やノードランナーのコミュニティに参加",

        // Pro
        boltz_pro_name: "SATS Routing Pro",
        boltz_pro_description: "スワップでsatsを稼げるプラットフォーム",
        boltz_pro_how_it_works_title: "仕組み",
        boltz_pro_how_it_works_description:
            "当社のリクイディティの再バランスに役立つ方向にスワップすることで報酬を得る",
        boltz_pro_chart_title: "SATS Routing Pro手数料履歴サンプル",
        boltz_pro_chart_y_axis: "SATS Routing Pro手数料",
        boltz_pro_chart_x_axis: "日付",
        boltz_pro_negative_fee: "satsを獲得",
        boltz_pro_lower_fee: "satsを節約",
        boltz_pro_regular_fee: "通常のSATS Routing手数料",
        boltz_pro_target_audience_title: "SATS Routing Proは誰のため？",
        boltz_pro_target_audience_subtitle:
            "日常の支払いではなく、satsを稼ぎたいプロフェッショナル向けに構築",
        boltz_pro_perfect_for_title: "最適なのは",
        boltz_pro_perfect_for_1:
            "過剰なインバウンドリクイディティを減らしてsatsを獲得したいLightningノードオペレーター",
        boltz_pro_perfect_for_2:
            "外部ノードオペレーターと協力してリクイディティを管理するプロフェッショナル",
        boltz_pro_perfect_for_3:
            "SATS Routing Proのルーティング制限内でLightningウォレットをチャージするユーザー",
        boltz_pro_not_designed_for_title: "適していないのは",
        boltz_pro_not_designed_for_1:
            "コーヒーを買うなどの日常的なLightning決済",
        boltz_pro_not_designed_for_2:
            "高いルーティング手数料の宛先への信頼性の高い支払い",
        boltz_pro_not_designed_for_3:
            "即座の支払い実行が保証されることを必要とするシナリオ",
        boltz_pro_cta_title: "今すぐsatsを獲得開始！",
        boltz_pro_cta_subtitle: "現在のsatsを稼ぐ機会を見つける",
        boltz_pro_options_title: "SATS Routing Proの3つの使用方法",
        boltz_pro_options_subtitle: "最適なものを選択",
        boltz_pro_option_client_title: "SATS Routingクライアント",
        boltz_pro_option_client_description:
            "APIとCLI経由でSATS Routing Proを完全に自動化",
        boltz_pro_option_web_title: "Webアプリ",
        boltz_pro_option_web_description:
            "SATS Routing Pro Webアプリで観察してスワップ",
        boltz_pro_option_chat_title: "チャットボット",
        boltz_pro_option_chat_description_prefix:
            "SATS Routing Pro の機会に関する即時通知を",
        boltz_pro_option_chat_description_middle: "または",
        boltz_pro_option_chat_description_suffix: "で受け取る。",

        balance: "残高",
        display: "表示",
        security: "セキュリティ",
        failed: "失敗",
        swaps_found: "スワップをスキャン中（{{ count }} 件見つかりました）",
        claim_scan_required:
            "このスワップを請求するには、レスキューファイルをアップロードして戻り、スキャンしてください。",
        refund_scan_required:
            "この残高を返金するには、レスキューファイルをアップロードして戻り、スキャンしてください。",
        refund_destination_hint:
            "資金は {{ network }} 上の {{ symbol }} として、接続中の EVM ウォレットに返金されます。",
        invalid_rescue_key_evm:
            "このレスキューキーはこのスワップに関連付けられていません。別のレスキューキーを使用してもう一度お試しください。",
        error_occurred: "エラーが発生しました：{{ error }}",
        rescue_external_select_method:
            "少なくとも1つの復旧方法を選択してください",
        rescue_external_subtitle:
            "履歴タブにないスワップを復旧するには、このページを使用してください。",
        rescue_external_report_issue_start:
            "当方側の問題によりスワップが失敗したと思われる場合は、",
        rescue_external_report_issue_link: "こちらをクリック",
        rescue_external_report_issue_end:
            "してログを共有し、スワップの詳細をお知らせください。",
        rescue_external_coverage: "提供された復旧方法で復旧可能",
        rescue_external_requires_rescue_key: "レスキューキーが必要です",
        rescue_external_requires_wallet: "ウォレットが必要です",
        rescue_external_requires_rescue_key_wallet:
            "レスキューキーとウォレットが必要です",
        rescue_external_resume: "再開",
        evm_rescue_prompt:
            "EVM チェーン上の SATS Routing スワップに資金を送金した場合は「スワップを返金」を使用し、EVM チェーンから資金を受け取っていた場合は「スワップを再開」を使用して、このブラウザのスワップ履歴にないスワップを救済してください。",
        evm_rescue_refund_title: "スワップを返金",
        start_scanning: "スキャンを開始",
        stop_scanning: "スキャンを停止",
        evm_rescue_resume_title: "スワップを再開",
        evm_rescue_resume_explainer:
            "レスキューキーを使用して、再開できる保留中のスワップを見つけます。",
        unmatched_swaps:
            "このウォレットには追加で {{ count }} 件の請求可能なスワップがあります。アクセスするには、これらのスワップの開始に使用したレスキューキーに切り替えてください。",
        approve: "承認",
        approve_allowance_line:
            "スワップコントラクトの{{ tokenStandard }}許可額を設定",
        approve_allowance_reset_line:
            "一部の{{ tokenStandard }}トークンでは、新しい金額を設定する前に許可額を0にリセットする必要があります。2回承認が必要になる場合があります。",
        upload_rescue_key: "レスキューキーを選択",

        suspension_status: "スワップサービス停止中",
        suspension_p1:
            "お知らせ：SATS Routing は追って通知があるまで停止したままとなります。",
        suspension_p2:
            "当社の API は、協調的な返金処理のために引き続き利用可能です。いずれにせよ、一方的な返金は当社のインフラに依存しないため機能します。",
        suspension_p3: "サポートチームには引き続きご連絡いただけます。",
        suspension_p4:
            "明確にしておきますが、これは単一のインシデントへの対応ではありません。ここ数か月、当社のインフラに対する自動化された AI 支援型の探索が着実に増加しており、複数のエクスプロイトに対処してきました。いずれも封じ込めましたが、傾向は明らかです。攻撃者は、当社の規模のチームが発見して修正できるよりも速く反復するようになりました。ここ数日だけでも急激な加速が見られ、この非対称性が逆転するとは考えていません。当社自身による最近のセキュリティスキャンの結果を検討した上で、SATS Routing のスワップを責任を持って再開することはできません。とりわけ、修正の展開を急ぐ一方で、潤沢なリソースを持つと見られる複数のグループから積極的に狙われている状況ではなおさらです。",
        suspension_p5:
            "私たちが目にしているのは、オープンソースのスタック上で運用されるビットコインサービスにとっての大きなパラダイムシフトであり、慎重な分析が必要です。スワップサービスがすぐに再開するとは考えないでください。",
        suspension_p6:
            "はっきりと申し上げます。ユーザーの資金が危険にさらされたことは一度もありません。SATS Routing は設計上ノンカストディアルです。そして完全に自己資金で運営する企業として、損失はすべて当社が負いました。",
        suspension_p7:
            "ここから先どうなるかはまだわかりませんが、一息ついて判断できる時間が取れ次第、あらためてお知らせします 🙏",
        suspension_date: "2026年8月3日 · X で見る",
    },
};

type NestedKeyOf<T> = {
    [K in keyof T & string]: T[K] extends object
        ? `${K}.${NestedKeyOf<T[K]>}`
        : K;
}[keyof T & string];

export type DictKey = NestedKeyOf<typeof dict.en>;

export type Language = keyof typeof dict;

export const rawDict = JSON.parse(JSON.stringify(dict));

Object.entries(dict)
    .filter(([lang]) => lang !== "en")
    .map(([, langDict]) => {
        Object.entries(dict.en).map(([key, enVal]) => {
            const dictKey = key as keyof typeof dict.en;
            if (langDict[dictKey] === undefined) {
                (langDict as Record<keyof typeof dict.en, unknown>)[dictKey] =
                    enVal;
            }
        });
    });

export default dict;
